/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import * as coreClient from "@azure/core-client";

export const EventGridEvent: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventGridEvent",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
      topic: {
        serializedName: "topic",
        type: {
          name: "String",
        },
      },
      subject: {
        serializedName: "subject",
        required: true,
        type: {
          name: "String",
        },
      },
      data: {
        serializedName: "data",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
      eventType: {
        serializedName: "eventType",
        required: true,
        type: {
          name: "String",
        },
      },
      eventTime: {
        serializedName: "eventTime",
        required: true,
        type: {
          name: "DateTime",
        },
      },
      metadataVersion: {
        serializedName: "metadataVersion",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      dataVersion: {
        serializedName: "dataVersion",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CloudEvent: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CloudEvent",
    additionalProperties: { type: { name: "Object" } },
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
      source: {
        serializedName: "source",
        required: true,
        type: {
          name: "String",
        },
      },
      data: {
        serializedName: "data",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
      dataBase64: {
        serializedName: "data_base64",
        type: {
          name: "ByteArray",
        },
      },
      type: {
        serializedName: "type",
        required: true,
        type: {
          name: "String",
        },
      },
      time: {
        serializedName: "time",
        type: {
          name: "DateTime",
        },
      },
      specversion: {
        serializedName: "specversion",
        required: true,
        type: {
          name: "String",
        },
      },
      dataschema: {
        serializedName: "dataschema",
        type: {
          name: "String",
        },
      },
      datacontenttype: {
        serializedName: "datacontenttype",
        type: {
          name: "String",
        },
      },
      subject: {
        serializedName: "subject",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const StorageBlobCreatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageBlobCreatedEventData",
    modelProperties: {
      api: {
        serializedName: "api",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        type: {
          name: "String",
        },
      },
      eTag: {
        serializedName: "eTag",
        type: {
          name: "String",
        },
      },
      contentType: {
        serializedName: "contentType",
        type: {
          name: "String",
        },
      },
      contentLength: {
        serializedName: "contentLength",
        type: {
          name: "Number",
        },
      },
      contentOffset: {
        serializedName: "contentOffset",
        type: {
          name: "Number",
        },
      },
      blobType: {
        serializedName: "blobType",
        type: {
          name: "String",
        },
      },
      accessTier: {
        serializedName: "accessTier",
        required: true,
        type: {
          name: "String",
        },
      },
      url: {
        serializedName: "url",
        type: {
          name: "String",
        },
      },
      sequencer: {
        serializedName: "sequencer",
        type: {
          name: "String",
        },
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "String",
        },
      },
      storageDiagnostics: {
        serializedName: "storageDiagnostics",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
    },
  },
};

export const StorageBlobDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageBlobDeletedEventData",
    modelProperties: {
      api: {
        serializedName: "api",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      contentType: {
        serializedName: "contentType",
        required: true,
        type: {
          name: "String",
        },
      },
      blobType: {
        serializedName: "blobType",
        required: true,
        type: {
          name: "String",
        },
      },
      url: {
        serializedName: "url",
        required: true,
        type: {
          name: "String",
        },
      },
      sequencer: {
        serializedName: "sequencer",
        required: true,
        type: {
          name: "String",
        },
      },
      identity: {
        serializedName: "identity",
        required: true,
        type: {
          name: "String",
        },
      },
      storageDiagnostics: {
        serializedName: "storageDiagnostics",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
    },
  },
};

export const StorageDirectoryCreatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageDirectoryCreatedEventData",
    modelProperties: {
      api: {
        serializedName: "api",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      eTag: {
        serializedName: "eTag",
        required: true,
        type: {
          name: "String",
        },
      },
      url: {
        serializedName: "url",
        required: true,
        type: {
          name: "String",
        },
      },
      sequencer: {
        serializedName: "sequencer",
        required: true,
        type: {
          name: "String",
        },
      },
      identity: {
        serializedName: "identity",
        required: true,
        type: {
          name: "String",
        },
      },
      storageDiagnostics: {
        serializedName: "storageDiagnostics",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
    },
  },
};

export const StorageDirectoryDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageDirectoryDeletedEventData",
    modelProperties: {
      api: {
        serializedName: "api",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      url: {
        serializedName: "url",
        required: true,
        type: {
          name: "String",
        },
      },
      recursive: {
        serializedName: "recursive",
        required: true,
        type: {
          name: "String",
        },
      },
      sequencer: {
        serializedName: "sequencer",
        required: true,
        type: {
          name: "String",
        },
      },
      identity: {
        serializedName: "identity",
        required: true,
        type: {
          name: "String",
        },
      },
      storageDiagnostics: {
        serializedName: "storageDiagnostics",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
    },
  },
};

export const StorageBlobRenamedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageBlobRenamedEventData",
    modelProperties: {
      api: {
        serializedName: "api",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      sourceUrl: {
        serializedName: "sourceUrl",
        required: true,
        type: {
          name: "String",
        },
      },
      destinationUrl: {
        serializedName: "destinationUrl",
        required: true,
        type: {
          name: "String",
        },
      },
      sequencer: {
        serializedName: "sequencer",
        required: true,
        type: {
          name: "String",
        },
      },
      identity: {
        serializedName: "identity",
        required: true,
        type: {
          name: "String",
        },
      },
      storageDiagnostics: {
        serializedName: "storageDiagnostics",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
    },
  },
};

export const StorageDirectoryRenamedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageDirectoryRenamedEventData",
    modelProperties: {
      api: {
        serializedName: "api",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      sourceUrl: {
        serializedName: "sourceUrl",
        required: true,
        type: {
          name: "String",
        },
      },
      destinationUrl: {
        serializedName: "destinationUrl",
        required: true,
        type: {
          name: "String",
        },
      },
      sequencer: {
        serializedName: "sequencer",
        required: true,
        type: {
          name: "String",
        },
      },
      identity: {
        serializedName: "identity",
        required: true,
        type: {
          name: "String",
        },
      },
      storageDiagnostics: {
        serializedName: "storageDiagnostics",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
    },
  },
};

export const StorageLifecyclePolicyCompletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "StorageLifecyclePolicyCompletedEventData",
      modelProperties: {
        scheduleTime: {
          serializedName: "scheduleTime",
          required: true,
          type: {
            name: "String",
          },
        },
        policyRunSummary: {
          serializedName: "policyRunSummary",
          type: {
            name: "Composite",
            className: "StorageLifecyclePolicyRunSummary",
          },
        },
        deleteSummary: {
          serializedName: "deleteSummary",
          type: {
            name: "Composite",
            className: "StorageLifecyclePolicyActionSummaryDetail",
          },
        },
        tierToCoolSummary: {
          serializedName: "tierToCoolSummary",
          type: {
            name: "Composite",
            className: "StorageLifecyclePolicyActionSummaryDetail",
          },
        },
        tierToColdSummary: {
          serializedName: "tierToColdSummary",
          type: {
            name: "Composite",
            className: "StorageLifecyclePolicyActionSummaryDetail",
          },
        },
        tierToArchiveSummary: {
          serializedName: "tierToArchiveSummary",
          type: {
            name: "Composite",
            className: "StorageLifecyclePolicyActionSummaryDetail",
          },
        },
      },
    },
  };

export const StorageLifecyclePolicyRunSummary: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageLifecyclePolicyRunSummary",
    modelProperties: {
      completionStatus: {
        serializedName: "completionStatus",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const StorageLifecyclePolicyActionSummaryDetail: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "StorageLifecyclePolicyActionSummaryDetail",
      modelProperties: {
        totalObjectsCount: {
          serializedName: "totalObjectsCount",
          required: true,
          type: {
            name: "Number",
          },
        },
        successCount: {
          serializedName: "successCount",
          required: true,
          type: {
            name: "Number",
          },
        },
        errorList: {
          serializedName: "errorList",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const StorageBlobTierChangedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageBlobTierChangedEventData",
    modelProperties: {
      api: {
        serializedName: "api",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        type: {
          name: "String",
        },
      },
      contentType: {
        serializedName: "contentType",
        type: {
          name: "String",
        },
      },
      contentLength: {
        serializedName: "contentLength",
        type: {
          name: "Number",
        },
      },
      blobType: {
        serializedName: "blobType",
        type: {
          name: "String",
        },
      },
      accessTier: {
        serializedName: "accessTier",
        required: true,
        type: {
          name: "String",
        },
      },
      previousTier: {
        serializedName: "previousTier",
        required: true,
        type: {
          name: "String",
        },
      },
      url: {
        serializedName: "url",
        type: {
          name: "String",
        },
      },
      sequencer: {
        serializedName: "sequencer",
        type: {
          name: "String",
        },
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "String",
        },
      },
      storageDiagnostics: {
        serializedName: "storageDiagnostics",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
    },
  },
};

export const StorageAsyncOperationInitiatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "StorageAsyncOperationInitiatedEventData",
      modelProperties: {
        api: {
          serializedName: "api",
          required: true,
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "clientRequestId",
          required: true,
          type: {
            name: "String",
          },
        },
        requestId: {
          serializedName: "requestId",
          required: true,
          type: {
            name: "String",
          },
        },
        contentType: {
          serializedName: "contentType",
          required: true,
          type: {
            name: "String",
          },
        },
        contentLength: {
          serializedName: "contentLength",
          required: true,
          type: {
            name: "Number",
          },
        },
        blobType: {
          serializedName: "blobType",
          required: true,
          type: {
            name: "String",
          },
        },
        url: {
          serializedName: "url",
          required: true,
          type: {
            name: "String",
          },
        },
        sequencer: {
          serializedName: "sequencer",
          required: true,
          type: {
            name: "String",
          },
        },
        identity: {
          serializedName: "identity",
          required: true,
          type: {
            name: "String",
          },
        },
        storageDiagnostics: {
          serializedName: "storageDiagnostics",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "any" } },
          },
        },
      },
    },
  };

export const StorageBlobInventoryPolicyCompletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "StorageBlobInventoryPolicyCompletedEventData",
      modelProperties: {
        scheduleDateTime: {
          serializedName: "scheduleDateTime",
          required: true,
          type: {
            name: "String",
          },
        },
        accountName: {
          serializedName: "accountName",
          required: true,
          type: {
            name: "String",
          },
        },
        ruleName: {
          serializedName: "ruleName",
          required: true,
          type: {
            name: "String",
          },
        },
        policyRunStatus: {
          serializedName: "policyRunStatus",
          required: true,
          type: {
            name: "String",
          },
        },
        policyRunStatusMessage: {
          serializedName: "policyRunStatusMessage",
          required: true,
          type: {
            name: "String",
          },
        },
        policyRunId: {
          serializedName: "policyRunId",
          required: true,
          type: {
            name: "String",
          },
        },
        manifestBlobUrl: {
          serializedName: "manifestBlobUrl",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const StorageTaskQueuedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageTaskQueuedEventData",
    modelProperties: {
      queuedDateTime: {
        serializedName: "queuedDateTime",
        required: true,
        type: {
          name: "String",
        },
      },
      taskExecutionId: {
        serializedName: "taskExecutionId",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const StorageTaskCompletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageTaskCompletedEventData",
    modelProperties: {
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      completedDateTime: {
        serializedName: "completedDateTime",
        required: true,
        type: {
          name: "String",
        },
      },
      taskExecutionId: {
        serializedName: "taskExecutionId",
        required: true,
        type: {
          name: "String",
        },
      },
      taskName: {
        serializedName: "taskName",
        required: true,
        type: {
          name: "String",
        },
      },
      summaryReportBlobUrl: {
        serializedName: "summaryReportBlobUrl",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const StorageTaskAssignmentQueuedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "StorageTaskAssignmentQueuedEventData",
      modelProperties: {
        queuedOn: {
          serializedName: "queuedDateTime",
          required: true,
          type: {
            name: "String",
          },
        },
        taskExecutionId: {
          serializedName: "taskExecutionId",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const StorageTaskAssignmentCompletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "StorageTaskAssignmentCompletedEventData",
      modelProperties: {
        status: {
          serializedName: "status",
          required: true,
          type: {
            name: "String",
          },
        },
        completedOn: {
          serializedName: "completedDateTime",
          required: true,
          type: {
            name: "String",
          },
        },
        taskExecutionId: {
          serializedName: "taskExecutionId",
          required: true,
          type: {
            name: "String",
          },
        },
        taskName: {
          serializedName: "taskName",
          required: true,
          type: {
            name: "String",
          },
        },
        summaryReportBlobUri: {
          serializedName: "summaryReportBlobUrl",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EventHubCaptureFileCreatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventHubCaptureFileCreatedEventData",
    modelProperties: {
      fileUrl: {
        serializedName: "fileUrl",
        required: true,
        type: {
          name: "String",
        },
      },
      fileType: {
        serializedName: "fileType",
        required: true,
        type: {
          name: "String",
        },
      },
      partitionId: {
        serializedName: "partitionId",
        required: true,
        type: {
          name: "String",
        },
      },
      sizeInBytes: {
        serializedName: "sizeInBytes",
        required: true,
        type: {
          name: "Number",
        },
      },
      eventCount: {
        serializedName: "eventCount",
        required: true,
        type: {
          name: "Number",
        },
      },
      firstSequenceNumber: {
        serializedName: "firstSequenceNumber",
        required: true,
        type: {
          name: "Number",
        },
      },
      lastSequenceNumber: {
        serializedName: "lastSequenceNumber",
        required: true,
        type: {
          name: "Number",
        },
      },
      firstEnqueueTime: {
        serializedName: "firstEnqueueTime",
        required: true,
        type: {
          name: "String",
        },
      },
      lastEnqueueTime: {
        serializedName: "lastEnqueueTime",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ResourceWriteSuccessEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ResourceWriteSuccessEventData",
    modelProperties: {
      tenantId: {
        serializedName: "tenantId",
        required: true,
        type: {
          name: "String",
        },
      },
      subscriptionId: {
        serializedName: "subscriptionId",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceGroup: {
        serializedName: "resourceGroup",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceProvider: {
        serializedName: "resourceProvider",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationName: {
        serializedName: "operationName",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      authorization: {
        serializedName: "authorization",
        type: {
          name: "Composite",
          className: "ResourceAuthorization",
        },
      },
      claims: {
        serializedName: "claims",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      correlationId: {
        serializedName: "correlationId",
        required: true,
        type: {
          name: "String",
        },
      },
      httpRequest: {
        serializedName: "httpRequest",
        type: {
          name: "Composite",
          className: "ResourceHttpRequest",
        },
      },
    },
  },
};

export const ResourceAuthorization: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ResourceAuthorization",
    modelProperties: {
      scope: {
        serializedName: "scope",
        required: true,
        type: {
          name: "String",
        },
      },
      action: {
        serializedName: "action",
        required: true,
        type: {
          name: "String",
        },
      },
      evidence: {
        serializedName: "evidence",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const ResourceHttpRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ResourceHttpRequest",
    modelProperties: {
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      clientIpAddress: {
        serializedName: "clientIpAddress",
        required: true,
        type: {
          name: "String",
        },
      },
      method: {
        serializedName: "method",
        required: true,
        type: {
          name: "String",
        },
      },
      url: {
        serializedName: "url",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ResourceWriteFailureEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ResourceWriteFailureEventData",
    modelProperties: {
      tenantId: {
        serializedName: "tenantId",
        required: true,
        type: {
          name: "String",
        },
      },
      subscriptionId: {
        serializedName: "subscriptionId",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceGroup: {
        serializedName: "resourceGroup",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceProvider: {
        serializedName: "resourceProvider",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationName: {
        serializedName: "operationName",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      authorization: {
        serializedName: "authorization",
        type: {
          name: "Composite",
          className: "ResourceAuthorization",
        },
      },
      claims: {
        serializedName: "claims",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      correlationId: {
        serializedName: "correlationId",
        required: true,
        type: {
          name: "String",
        },
      },
      httpRequest: {
        serializedName: "httpRequest",
        type: {
          name: "Composite",
          className: "ResourceHttpRequest",
        },
      },
    },
  },
};

export const ResourceWriteCancelEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ResourceWriteCancelEventData",
    modelProperties: {
      tenantId: {
        serializedName: "tenantId",
        required: true,
        type: {
          name: "String",
        },
      },
      subscriptionId: {
        serializedName: "subscriptionId",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceGroup: {
        serializedName: "resourceGroup",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceProvider: {
        serializedName: "resourceProvider",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationName: {
        serializedName: "operationName",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      authorization: {
        serializedName: "authorization",
        type: {
          name: "Composite",
          className: "ResourceAuthorization",
        },
      },
      claims: {
        serializedName: "claims",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      correlationId: {
        serializedName: "correlationId",
        required: true,
        type: {
          name: "String",
        },
      },
      httpRequest: {
        serializedName: "httpRequest",
        type: {
          name: "Composite",
          className: "ResourceHttpRequest",
        },
      },
    },
  },
};

export const ResourceDeleteSuccessEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ResourceDeleteSuccessEventData",
    modelProperties: {
      tenantId: {
        serializedName: "tenantId",
        required: true,
        type: {
          name: "String",
        },
      },
      subscriptionId: {
        serializedName: "subscriptionId",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceGroup: {
        serializedName: "resourceGroup",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceProvider: {
        serializedName: "resourceProvider",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationName: {
        serializedName: "operationName",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      authorization: {
        serializedName: "authorization",
        type: {
          name: "Composite",
          className: "ResourceAuthorization",
        },
      },
      claims: {
        serializedName: "claims",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      correlationId: {
        serializedName: "correlationId",
        required: true,
        type: {
          name: "String",
        },
      },
      httpRequest: {
        serializedName: "httpRequest",
        type: {
          name: "Composite",
          className: "ResourceHttpRequest",
        },
      },
    },
  },
};

export const ResourceDeleteFailureEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ResourceDeleteFailureEventData",
    modelProperties: {
      tenantId: {
        serializedName: "tenantId",
        required: true,
        type: {
          name: "String",
        },
      },
      subscriptionId: {
        serializedName: "subscriptionId",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceGroup: {
        serializedName: "resourceGroup",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceProvider: {
        serializedName: "resourceProvider",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationName: {
        serializedName: "operationName",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      authorization: {
        serializedName: "authorization",
        type: {
          name: "Composite",
          className: "ResourceAuthorization",
        },
      },
      claims: {
        serializedName: "claims",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      correlationId: {
        serializedName: "correlationId",
        required: true,
        type: {
          name: "String",
        },
      },
      httpRequest: {
        serializedName: "httpRequest",
        type: {
          name: "Composite",
          className: "ResourceHttpRequest",
        },
      },
    },
  },
};

export const ResourceDeleteCancelEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ResourceDeleteCancelEventData",
    modelProperties: {
      tenantId: {
        serializedName: "tenantId",
        required: true,
        type: {
          name: "String",
        },
      },
      subscriptionId: {
        serializedName: "subscriptionId",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceGroup: {
        serializedName: "resourceGroup",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceProvider: {
        serializedName: "resourceProvider",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationName: {
        serializedName: "operationName",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      authorization: {
        serializedName: "authorization",
        type: {
          name: "Composite",
          className: "ResourceAuthorization",
        },
      },
      claims: {
        serializedName: "claims",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      correlationId: {
        serializedName: "correlationId",
        required: true,
        type: {
          name: "String",
        },
      },
      httpRequest: {
        serializedName: "httpRequest",
        type: {
          name: "Composite",
          className: "ResourceHttpRequest",
        },
      },
    },
  },
};

export const ResourceActionSuccessEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ResourceActionSuccessEventData",
    modelProperties: {
      tenantId: {
        serializedName: "tenantId",
        required: true,
        type: {
          name: "String",
        },
      },
      subscriptionId: {
        serializedName: "subscriptionId",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceGroup: {
        serializedName: "resourceGroup",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceProvider: {
        serializedName: "resourceProvider",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationName: {
        serializedName: "operationName",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      authorization: {
        serializedName: "authorization",
        type: {
          name: "Composite",
          className: "ResourceAuthorization",
        },
      },
      claims: {
        serializedName: "claims",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      correlationId: {
        serializedName: "correlationId",
        required: true,
        type: {
          name: "String",
        },
      },
      httpRequest: {
        serializedName: "httpRequest",
        type: {
          name: "Composite",
          className: "ResourceHttpRequest",
        },
      },
    },
  },
};

export const ResourceActionFailureEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ResourceActionFailureEventData",
    modelProperties: {
      tenantId: {
        serializedName: "tenantId",
        required: true,
        type: {
          name: "String",
        },
      },
      subscriptionId: {
        serializedName: "subscriptionId",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceGroup: {
        serializedName: "resourceGroup",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceProvider: {
        serializedName: "resourceProvider",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationName: {
        serializedName: "operationName",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      authorization: {
        serializedName: "authorization",
        type: {
          name: "Composite",
          className: "ResourceAuthorization",
        },
      },
      claims: {
        serializedName: "claims",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      correlationId: {
        serializedName: "correlationId",
        required: true,
        type: {
          name: "String",
        },
      },
      httpRequest: {
        serializedName: "httpRequest",
        type: {
          name: "Composite",
          className: "ResourceHttpRequest",
        },
      },
    },
  },
};

export const ResourceActionCancelEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ResourceActionCancelEventData",
    modelProperties: {
      tenantId: {
        serializedName: "tenantId",
        required: true,
        type: {
          name: "String",
        },
      },
      subscriptionId: {
        serializedName: "subscriptionId",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceGroup: {
        serializedName: "resourceGroup",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceProvider: {
        serializedName: "resourceProvider",
        required: true,
        type: {
          name: "String",
        },
      },
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationName: {
        serializedName: "operationName",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      authorization: {
        serializedName: "authorization",
        type: {
          name: "Composite",
          className: "ResourceAuthorization",
        },
      },
      claims: {
        serializedName: "claims",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      correlationId: {
        serializedName: "correlationId",
        required: true,
        type: {
          name: "String",
        },
      },
      httpRequest: {
        serializedName: "httpRequest",
        type: {
          name: "Composite",
          className: "ResourceHttpRequest",
        },
      },
    },
  },
};

export const SubscriptionValidationEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SubscriptionValidationEventData",
    modelProperties: {
      validationCode: {
        serializedName: "validationCode",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      validationUrl: {
        serializedName: "validationUrl",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const SubscriptionValidationResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SubscriptionValidationResponse",
    modelProperties: {
      validationResponse: {
        serializedName: "validationResponse",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const SubscriptionDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SubscriptionDeletedEventData",
    modelProperties: {
      eventSubscriptionId: {
        serializedName: "eventSubscriptionId",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EventGridMqttClientEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventGridMqttClientEventData",
    modelProperties: {
      clientAuthenticationName: {
        serializedName: "clientAuthenticationName",
        required: true,
        type: {
          name: "String",
        },
      },
      clientName: {
        serializedName: "clientName",
        required: true,
        type: {
          name: "String",
        },
      },
      namespaceName: {
        serializedName: "namespaceName",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DataBoxCopyStartedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DataBoxCopyStartedEventData",
    modelProperties: {
      serialNumber: {
        serializedName: "serialNumber",
        required: true,
        type: {
          name: "String",
        },
      },
      stageName: {
        serializedName: "stageName",
        required: true,
        type: {
          name: "String",
        },
      },
      stageTime: {
        serializedName: "stageTime",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DataBoxCopyCompletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DataBoxCopyCompletedEventData",
    modelProperties: {
      serialNumber: {
        serializedName: "serialNumber",
        required: true,
        type: {
          name: "String",
        },
      },
      stageName: {
        serializedName: "stageName",
        required: true,
        type: {
          name: "String",
        },
      },
      stageTime: {
        serializedName: "stageTime",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DataBoxOrderCompletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DataBoxOrderCompletedEventData",
    modelProperties: {
      serialNumber: {
        serializedName: "serialNumber",
        required: true,
        type: {
          name: "String",
        },
      },
      stageName: {
        serializedName: "stageName",
        required: true,
        type: {
          name: "String",
        },
      },
      stageTime: {
        serializedName: "stageTime",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DeviceLifeCycleEvent: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeviceLifeCycleEvent",
    modelProperties: {
      deviceId: {
        serializedName: "deviceId",
        required: true,
        type: {
          name: "String",
        },
      },
      hubName: {
        serializedName: "hubName",
        required: true,
        type: {
          name: "String",
        },
      },
      twin: {
        serializedName: "twin",
        type: {
          name: "Composite",
          className: "DeviceTwinInfo",
        },
      },
    },
  },
};

export const DeviceTwinInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeviceTwinInfo",
    modelProperties: {
      authenticationType: {
        serializedName: "authenticationType",
        required: true,
        type: {
          name: "String",
        },
      },
      cloudToDeviceMessageCount: {
        serializedName: "cloudToDeviceMessageCount",
        required: true,
        type: {
          name: "Number",
        },
      },
      connectionState: {
        serializedName: "connectionState",
        required: true,
        type: {
          name: "String",
        },
      },
      deviceId: {
        serializedName: "deviceId",
        required: true,
        type: {
          name: "String",
        },
      },
      etag: {
        serializedName: "etag",
        required: true,
        type: {
          name: "String",
        },
      },
      lastActivityTime: {
        serializedName: "lastActivityTime",
        required: true,
        type: {
          name: "String",
        },
      },
      properties: {
        serializedName: "properties",
        type: {
          name: "Composite",
          className: "DeviceTwinInfoProperties",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
      statusUpdateTime: {
        serializedName: "statusUpdateTime",
        required: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "version",
        required: true,
        type: {
          name: "Number",
        },
      },
      x509Thumbprint: {
        serializedName: "x509Thumbprint",
        type: {
          name: "Composite",
          className: "DeviceTwinInfoX509Thumbprint",
        },
      },
    },
  },
};

export const DeviceTwinInfoProperties: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeviceTwinInfoProperties",
    modelProperties: {
      desired: {
        serializedName: "desired",
        type: {
          name: "Composite",
          className: "DeviceTwin",
        },
      },
      reported: {
        serializedName: "reported",
        type: {
          name: "Composite",
          className: "DeviceTwin",
        },
      },
    },
  },
};

export const DeviceTwin: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeviceTwin",
    modelProperties: {
      metadata: {
        serializedName: "metadata",
        type: {
          name: "Composite",
          className: "DeviceTwinMetadata",
        },
      },
      version: {
        serializedName: "version",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const DeviceTwinMetadata: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeviceTwinMetadata",
    modelProperties: {
      lastUpdated: {
        serializedName: "lastUpdated",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DeviceTwinInfoX509Thumbprint: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeviceTwinInfoX509Thumbprint",
    modelProperties: {
      primaryThumbprint: {
        serializedName: "primaryThumbprint",
        type: {
          name: "String",
        },
      },
      secondaryThumbprint: {
        serializedName: "secondaryThumbprint",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DeviceConnectionStateEvent: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeviceConnectionStateEvent",
    modelProperties: {
      deviceId: {
        serializedName: "deviceId",
        required: true,
        type: {
          name: "String",
        },
      },
      moduleId: {
        serializedName: "moduleId",
        required: true,
        type: {
          name: "String",
        },
      },
      hubName: {
        serializedName: "hubName",
        required: true,
        type: {
          name: "String",
        },
      },
      deviceConnectionStateEventInfo: {
        serializedName: "deviceConnectionStateEventInfo",
        type: {
          name: "Composite",
          className: "DeviceConnectionStateEventInfo",
        },
      },
    },
  },
};

export const DeviceConnectionStateEventInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeviceConnectionStateEventInfo",
    modelProperties: {
      sequenceNumber: {
        serializedName: "sequenceNumber",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DeviceTelemetryEvent: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeviceTelemetryEvent",
    modelProperties: {
      body: {
        serializedName: "body",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
      properties: {
        serializedName: "properties",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      systemProperties: {
        serializedName: "systemProperties",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const ContainerRegistryEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ContainerRegistryEventData",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
      timestamp: {
        serializedName: "timestamp",
        required: true,
        type: {
          name: "String",
        },
      },
      action: {
        serializedName: "action",
        required: true,
        type: {
          name: "String",
        },
      },
      location: {
        serializedName: "location",
        required: true,
        type: {
          name: "String",
        },
      },
      target: {
        serializedName: "target",
        type: {
          name: "Composite",
          className: "ContainerRegistryEventTarget",
        },
      },
      request: {
        serializedName: "request",
        type: {
          name: "Composite",
          className: "ContainerRegistryEventRequest",
        },
      },
      actor: {
        serializedName: "actor",
        type: {
          name: "Composite",
          className: "ContainerRegistryEventActor",
        },
      },
      source: {
        serializedName: "source",
        type: {
          name: "Composite",
          className: "ContainerRegistryEventSource",
        },
      },
      connectedRegistry: {
        serializedName: "connectedRegistry",
        type: {
          name: "Composite",
          className: "ContainerRegistryEventConnectedRegistry",
        },
      },
    },
  },
};

export const ContainerRegistryEventTarget: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ContainerRegistryEventTarget",
    modelProperties: {
      mediaType: {
        serializedName: "mediaType",
        required: true,
        type: {
          name: "String",
        },
      },
      size: {
        serializedName: "size",
        required: true,
        type: {
          name: "Number",
        },
      },
      digest: {
        serializedName: "digest",
        required: true,
        type: {
          name: "String",
        },
      },
      length: {
        serializedName: "length",
        required: true,
        type: {
          name: "Number",
        },
      },
      repository: {
        serializedName: "repository",
        required: true,
        type: {
          name: "String",
        },
      },
      url: {
        serializedName: "url",
        required: true,
        type: {
          name: "String",
        },
      },
      tag: {
        serializedName: "tag",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ContainerRegistryEventRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ContainerRegistryEventRequest",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
      addr: {
        serializedName: "addr",
        required: true,
        type: {
          name: "String",
        },
      },
      host: {
        serializedName: "host",
        required: true,
        type: {
          name: "String",
        },
      },
      method: {
        serializedName: "method",
        required: true,
        type: {
          name: "String",
        },
      },
      useragent: {
        serializedName: "useragent",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ContainerRegistryEventActor: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ContainerRegistryEventActor",
    modelProperties: {
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ContainerRegistryEventSource: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ContainerRegistryEventSource",
    modelProperties: {
      addr: {
        serializedName: "addr",
        required: true,
        type: {
          name: "String",
        },
      },
      instanceID: {
        serializedName: "instanceID",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ContainerRegistryEventConnectedRegistry: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerRegistryEventConnectedRegistry",
      modelProperties: {
        name: {
          serializedName: "name",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ContainerRegistryArtifactEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ContainerRegistryArtifactEventData",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
      timestamp: {
        serializedName: "timestamp",
        required: true,
        type: {
          name: "String",
        },
      },
      action: {
        serializedName: "action",
        required: true,
        type: {
          name: "String",
        },
      },
      location: {
        serializedName: "location",
        required: true,
        type: {
          name: "String",
        },
      },
      target: {
        serializedName: "target",
        type: {
          name: "Composite",
          className: "ContainerRegistryArtifactEventTarget",
        },
      },
      connectedRegistry: {
        serializedName: "connectedRegistry",
        type: {
          name: "Composite",
          className: "ContainerRegistryEventConnectedRegistry",
        },
      },
    },
  },
};

export const ContainerRegistryArtifactEventTarget: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerRegistryArtifactEventTarget",
      modelProperties: {
        mediaType: {
          serializedName: "mediaType",
          required: true,
          type: {
            name: "String",
          },
        },
        size: {
          serializedName: "size",
          required: true,
          type: {
            name: "Number",
          },
        },
        digest: {
          serializedName: "digest",
          required: true,
          type: {
            name: "String",
          },
        },
        repository: {
          serializedName: "repository",
          required: true,
          type: {
            name: "String",
          },
        },
        tag: {
          serializedName: "tag",
          required: true,
          type: {
            name: "String",
          },
        },
        name: {
          serializedName: "name",
          required: true,
          type: {
            name: "String",
          },
        },
        version: {
          serializedName: "version",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ServiceBusActiveMessagesAvailableWithNoListenersEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ServiceBusActiveMessagesAvailableWithNoListenersEventData",
      modelProperties: {
        namespaceName: {
          serializedName: "namespaceName",
          required: true,
          type: {
            name: "String",
          },
        },
        requestUri: {
          serializedName: "requestUri",
          required: true,
          type: {
            name: "String",
          },
        },
        entityType: {
          serializedName: "entityType",
          required: true,
          type: {
            name: "String",
          },
        },
        queueName: {
          serializedName: "queueName",
          required: true,
          type: {
            name: "String",
          },
        },
        topicName: {
          serializedName: "topicName",
          required: true,
          type: {
            name: "String",
          },
        },
        subscriptionName: {
          serializedName: "subscriptionName",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ServiceBusDeadletterMessagesAvailableWithNoListenersEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "ServiceBusDeadletterMessagesAvailableWithNoListenersEventData",
      modelProperties: {
        namespaceName: {
          serializedName: "namespaceName",
          required: true,
          type: {
            name: "String",
          },
        },
        requestUri: {
          serializedName: "requestUri",
          required: true,
          type: {
            name: "String",
          },
        },
        entityType: {
          serializedName: "entityType",
          required: true,
          type: {
            name: "String",
          },
        },
        queueName: {
          serializedName: "queueName",
          required: true,
          type: {
            name: "String",
          },
        },
        topicName: {
          serializedName: "topicName",
          required: true,
          type: {
            name: "String",
          },
        },
        subscriptionName: {
          serializedName: "subscriptionName",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ServiceBusActiveMessagesAvailablePeriodicNotificationsEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "ServiceBusActiveMessagesAvailablePeriodicNotificationsEventData",
      modelProperties: {
        namespaceName: {
          serializedName: "namespaceName",
          required: true,
          type: {
            name: "String",
          },
        },
        requestUri: {
          serializedName: "requestUri",
          required: true,
          type: {
            name: "String",
          },
        },
        entityType: {
          serializedName: "entityType",
          required: true,
          type: {
            name: "String",
          },
        },
        queueName: {
          serializedName: "queueName",
          required: true,
          type: {
            name: "String",
          },
        },
        topicName: {
          serializedName: "topicName",
          required: true,
          type: {
            name: "String",
          },
        },
        subscriptionName: {
          serializedName: "subscriptionName",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ServiceBusDeadletterMessagesAvailablePeriodicNotificationsEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "ServiceBusDeadletterMessagesAvailablePeriodicNotificationsEventData",
      modelProperties: {
        namespaceName: {
          serializedName: "namespaceName",
          required: true,
          type: {
            name: "String",
          },
        },
        requestUri: {
          serializedName: "requestUri",
          required: true,
          type: {
            name: "String",
          },
        },
        entityType: {
          serializedName: "entityType",
          required: true,
          type: {
            name: "String",
          },
        },
        queueName: {
          serializedName: "queueName",
          required: true,
          type: {
            name: "String",
          },
        },
        topicName: {
          serializedName: "topicName",
          required: true,
          type: {
            name: "String",
          },
        },
        subscriptionName: {
          serializedName: "subscriptionName",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MediaJobStateChangeEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobStateChangeEventData",
    modelProperties: {
      previousState: {
        serializedName: "previousState",
        required: true,
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Canceled",
            "Canceling",
            "Error",
            "Finished",
            "Processing",
            "Queued",
            "Scheduled",
          ],
        },
      },
      state: {
        serializedName: "state",
        required: true,
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Canceled",
            "Canceling",
            "Error",
            "Finished",
            "Processing",
            "Queued",
            "Scheduled",
          ],
        },
      },
      correlationData: {
        serializedName: "correlationData",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const MediaJobError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobError",
    modelProperties: {
      code: {
        serializedName: "code",
        required: true,
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "ServiceError",
            "ServiceTransientError",
            "DownloadNotAccessible",
            "DownloadTransientError",
            "UploadNotAccessible",
            "UploadTransientError",
            "ConfigurationUnsupported",
            "ContentMalformed",
            "ContentUnsupported",
            "IdentityUnsupported",
          ],
        },
      },
      message: {
        serializedName: "message",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      category: {
        serializedName: "category",
        required: true,
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Service",
            "Download",
            "Upload",
            "Configuration",
            "Content",
            "Account",
          ],
        },
      },
      retry: {
        serializedName: "retry",
        required: true,
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: ["DoNotRetry", "MayRetry"],
        },
      },
      details: {
        serializedName: "details",
        required: true,
        readOnly: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MediaJobErrorDetail",
            },
          },
        },
      },
    },
  },
};

export const MediaJobErrorDetail: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobErrorDetail",
    modelProperties: {
      code: {
        serializedName: "code",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      message: {
        serializedName: "message",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MediaJobOutput: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobOutput",
    uberParent: "MediaJobOutput",
    polymorphicDiscriminator: {
      serializedName: "@odata\\.type",
      clientName: "odataType",
    },
    modelProperties: {
      odataType: {
        serializedName: "@odata\\.type",
        required: true,
        type: {
          name: "String",
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "MediaJobError",
        },
      },
      label: {
        serializedName: "label",
        type: {
          name: "String",
        },
      },
      progress: {
        serializedName: "progress",
        required: true,
        type: {
          name: "Number",
        },
      },
      state: {
        serializedName: "state",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Canceled",
            "Canceling",
            "Error",
            "Finished",
            "Processing",
            "Queued",
            "Scheduled",
          ],
        },
      },
    },
  },
};

export const MediaJobOutputProgressEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobOutputProgressEventData",
    modelProperties: {
      label: {
        serializedName: "label",
        required: true,
        type: {
          name: "String",
        },
      },
      progress: {
        serializedName: "progress",
        required: true,
        type: {
          name: "Number",
        },
      },
      jobCorrelationData: {
        serializedName: "jobCorrelationData",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const MediaJobOutputStateChangeEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobOutputStateChangeEventData",
    modelProperties: {
      previousState: {
        serializedName: "previousState",
        required: true,
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Canceled",
            "Canceling",
            "Error",
            "Finished",
            "Processing",
            "Queued",
            "Scheduled",
          ],
        },
      },
      output: {
        serializedName: "output",
        type: {
          name: "Composite",
          className: "MediaJobOutput",
        },
      },
      jobCorrelationData: {
        serializedName: "jobCorrelationData",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const MediaLiveEventEncoderConnectedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MediaLiveEventEncoderConnectedEventData",
      modelProperties: {
        ingestUrl: {
          serializedName: "ingestUrl",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        streamId: {
          serializedName: "streamId",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        encoderIp: {
          serializedName: "encoderIp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        encoderPort: {
          serializedName: "encoderPort",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MediaLiveEventConnectionRejectedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MediaLiveEventConnectionRejectedEventData",
      modelProperties: {
        ingestUrl: {
          serializedName: "ingestUrl",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        streamId: {
          serializedName: "streamId",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        encoderIp: {
          serializedName: "encoderIp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        encoderPort: {
          serializedName: "encoderPort",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        resultCode: {
          serializedName: "resultCode",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MediaLiveEventEncoderDisconnectedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MediaLiveEventEncoderDisconnectedEventData",
      modelProperties: {
        ingestUrl: {
          serializedName: "ingestUrl",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        streamId: {
          serializedName: "streamId",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        encoderIp: {
          serializedName: "encoderIp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        encoderPort: {
          serializedName: "encoderPort",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        resultCode: {
          serializedName: "resultCode",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MediaLiveEventIncomingStreamReceivedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MediaLiveEventIncomingStreamReceivedEventData",
      modelProperties: {
        ingestUrl: {
          serializedName: "ingestUrl",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        trackType: {
          serializedName: "trackType",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        trackName: {
          serializedName: "trackName",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        bitrate: {
          serializedName: "bitrate",
          required: true,
          readOnly: true,
          type: {
            name: "Number",
          },
        },
        encoderIp: {
          serializedName: "encoderIp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        encoderPort: {
          serializedName: "encoderPort",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        timestamp: {
          serializedName: "timestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        duration: {
          serializedName: "duration",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        timescale: {
          serializedName: "timescale",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MediaLiveEventIncomingStreamsOutOfSyncEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MediaLiveEventIncomingStreamsOutOfSyncEventData",
      modelProperties: {
        minLastTimestamp: {
          serializedName: "minLastTimestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        typeOfStreamWithMinLastTimestamp: {
          serializedName: "typeOfStreamWithMinLastTimestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        maxLastTimestamp: {
          serializedName: "maxLastTimestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        typeOfStreamWithMaxLastTimestamp: {
          serializedName: "typeOfStreamWithMaxLastTimestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        timescaleOfMinLastTimestamp: {
          serializedName: "timescaleOfMinLastTimestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        timescaleOfMaxLastTimestamp: {
          serializedName: "timescaleOfMaxLastTimestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MediaLiveEventIncomingVideoStreamsOutOfSyncEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MediaLiveEventIncomingVideoStreamsOutOfSyncEventData",
      modelProperties: {
        firstTimestamp: {
          serializedName: "firstTimestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        firstDuration: {
          serializedName: "firstDuration",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        secondTimestamp: {
          serializedName: "secondTimestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        secondDuration: {
          serializedName: "secondDuration",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        timescale: {
          serializedName: "timescale",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MediaLiveEventIncomingDataChunkDroppedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MediaLiveEventIncomingDataChunkDroppedEventData",
      modelProperties: {
        timestamp: {
          serializedName: "timestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        trackType: {
          serializedName: "trackType",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        bitrate: {
          serializedName: "bitrate",
          required: true,
          readOnly: true,
          type: {
            name: "Number",
          },
        },
        timescale: {
          serializedName: "timescale",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        resultCode: {
          serializedName: "resultCode",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        trackName: {
          serializedName: "trackName",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MediaLiveEventIngestHeartbeatEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MediaLiveEventIngestHeartbeatEventData",
      modelProperties: {
        trackType: {
          serializedName: "trackType",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        trackName: {
          serializedName: "trackName",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        transcriptionLanguage: {
          serializedName: "transcriptionLanguage",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        transcriptionState: {
          serializedName: "transcriptionState",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        bitrate: {
          serializedName: "bitrate",
          required: true,
          readOnly: true,
          type: {
            name: "Number",
          },
        },
        incomingBitrate: {
          serializedName: "incomingBitrate",
          required: true,
          readOnly: true,
          type: {
            name: "Number",
          },
        },
        ingestDriftValue: {
          serializedName: "ingestDriftValue",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        lastFragmentArrivalTime: {
          serializedName: "lastFragmentArrivalTime",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        lastTimestamp: {
          serializedName: "lastTimestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        timescale: {
          serializedName: "timescale",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        overlapCount: {
          serializedName: "overlapCount",
          required: true,
          readOnly: true,
          type: {
            name: "Number",
          },
        },
        discontinuityCount: {
          serializedName: "discontinuityCount",
          required: true,
          readOnly: true,
          type: {
            name: "Number",
          },
        },
        nonincreasingCount: {
          serializedName: "nonincreasingCount",
          required: true,
          readOnly: true,
          type: {
            name: "Number",
          },
        },
        unexpectedBitrate: {
          serializedName: "unexpectedBitrate",
          required: true,
          readOnly: true,
          type: {
            name: "Boolean",
          },
        },
        state: {
          serializedName: "state",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        healthy: {
          serializedName: "healthy",
          required: true,
          readOnly: true,
          type: {
            name: "Boolean",
          },
        },
      },
    },
  };

export const MediaLiveEventTrackDiscontinuityDetectedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MediaLiveEventTrackDiscontinuityDetectedEventData",
      modelProperties: {
        trackType: {
          serializedName: "trackType",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        trackName: {
          serializedName: "trackName",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        bitrate: {
          serializedName: "bitrate",
          required: true,
          readOnly: true,
          type: {
            name: "Number",
          },
        },
        previousTimestamp: {
          serializedName: "previousTimestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        newTimestamp: {
          serializedName: "newTimestamp",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        timescale: {
          serializedName: "timescale",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        discontinuityGap: {
          serializedName: "discontinuityGap",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MediaLiveEventChannelArchiveHeartbeatEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MediaLiveEventChannelArchiveHeartbeatEventData",
      modelProperties: {
        channelLatencyMs: {
          serializedName: "channelLatencyMs",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        latencyResultCode: {
          serializedName: "latencyResultCode",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MapsGeofenceEvent: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MapsGeofenceEvent",
    modelProperties: {
      expiredGeofenceGeometryId: {
        serializedName: "expiredGeofenceGeometryId",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      geometries: {
        serializedName: "geometries",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MapsGeofenceGeometry",
            },
          },
        },
      },
      invalidPeriodGeofenceGeometryId: {
        serializedName: "invalidPeriodGeofenceGeometryId",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      isEventPublished: {
        serializedName: "isEventPublished",
        required: true,
        type: {
          name: "Boolean",
        },
      },
    },
  },
};

export const MapsGeofenceGeometry: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MapsGeofenceGeometry",
    modelProperties: {
      deviceId: {
        serializedName: "deviceId",
        required: true,
        type: {
          name: "String",
        },
      },
      distance: {
        serializedName: "distance",
        required: true,
        type: {
          name: "Number",
        },
      },
      geometryId: {
        serializedName: "geometryId",
        required: true,
        type: {
          name: "String",
        },
      },
      nearestLat: {
        serializedName: "nearestLat",
        required: true,
        type: {
          name: "Number",
        },
      },
      nearestLon: {
        serializedName: "nearestLon",
        required: true,
        type: {
          name: "Number",
        },
      },
      udId: {
        serializedName: "udId",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AppConfigurationKeyValueModifiedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AppConfigurationKeyValueModifiedEventData",
      modelProperties: {
        key: {
          serializedName: "key",
          required: true,
          type: {
            name: "String",
          },
        },
        label: {
          serializedName: "label",
          required: true,
          type: {
            name: "String",
          },
        },
        etag: {
          serializedName: "etag",
          required: true,
          type: {
            name: "String",
          },
        },
        syncToken: {
          serializedName: "syncToken",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AppConfigurationKeyValueDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AppConfigurationKeyValueDeletedEventData",
      modelProperties: {
        key: {
          serializedName: "key",
          required: true,
          type: {
            name: "String",
          },
        },
        label: {
          serializedName: "label",
          required: true,
          type: {
            name: "String",
          },
        },
        etag: {
          serializedName: "etag",
          required: true,
          type: {
            name: "String",
          },
        },
        syncToken: {
          serializedName: "syncToken",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AppConfigurationSnapshotEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AppConfigurationSnapshotEventData",
    modelProperties: {
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      etag: {
        serializedName: "etag",
        required: true,
        type: {
          name: "String",
        },
      },
      syncToken: {
        serializedName: "syncToken",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const SignalRServiceClientConnectionConnectedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "SignalRServiceClientConnectionConnectedEventData",
      modelProperties: {
        timestamp: {
          serializedName: "timestamp",
          required: true,
          type: {
            name: "String",
          },
        },
        hubName: {
          serializedName: "hubName",
          required: true,
          type: {
            name: "String",
          },
        },
        connectionId: {
          serializedName: "connectionId",
          required: true,
          type: {
            name: "String",
          },
        },
        userId: {
          serializedName: "userId",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const SignalRServiceClientConnectionDisconnectedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "SignalRServiceClientConnectionDisconnectedEventData",
      modelProperties: {
        timestamp: {
          serializedName: "timestamp",
          required: true,
          type: {
            name: "String",
          },
        },
        hubName: {
          serializedName: "hubName",
          required: true,
          type: {
            name: "String",
          },
        },
        connectionId: {
          serializedName: "connectionId",
          required: true,
          type: {
            name: "String",
          },
        },
        userId: {
          serializedName: "userId",
          required: true,
          type: {
            name: "String",
          },
        },
        errorMessage: {
          serializedName: "errorMessage",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const KeyVaultCertificateNewVersionCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "KeyVaultCertificateNewVersionCreatedEventData",
      modelProperties: {
        id: {
          serializedName: "Id",
          required: true,
          type: {
            name: "String",
          },
        },
        vaultName: {
          serializedName: "VaultName",
          required: true,
          type: {
            name: "String",
          },
        },
        objectType: {
          serializedName: "ObjectType",
          required: true,
          type: {
            name: "String",
          },
        },
        objectName: {
          serializedName: "ObjectName",
          required: true,
          type: {
            name: "String",
          },
        },
        version: {
          serializedName: "Version",
          required: true,
          type: {
            name: "String",
          },
        },
        nbf: {
          serializedName: "NBF",
          required: true,
          type: {
            name: "Number",
          },
        },
        exp: {
          serializedName: "EXP",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const KeyVaultCertificateNearExpiryEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "KeyVaultCertificateNearExpiryEventData",
      modelProperties: {
        id: {
          serializedName: "Id",
          required: true,
          type: {
            name: "String",
          },
        },
        vaultName: {
          serializedName: "VaultName",
          required: true,
          type: {
            name: "String",
          },
        },
        objectType: {
          serializedName: "ObjectType",
          required: true,
          type: {
            name: "String",
          },
        },
        objectName: {
          serializedName: "ObjectName",
          required: true,
          type: {
            name: "String",
          },
        },
        version: {
          serializedName: "Version",
          required: true,
          type: {
            name: "String",
          },
        },
        nbf: {
          serializedName: "NBF",
          required: true,
          type: {
            name: "Number",
          },
        },
        exp: {
          serializedName: "EXP",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const KeyVaultCertificateExpiredEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "KeyVaultCertificateExpiredEventData",
    modelProperties: {
      id: {
        serializedName: "Id",
        required: true,
        type: {
          name: "String",
        },
      },
      vaultName: {
        serializedName: "VaultName",
        required: true,
        type: {
          name: "String",
        },
      },
      objectType: {
        serializedName: "ObjectType",
        required: true,
        type: {
          name: "String",
        },
      },
      objectName: {
        serializedName: "ObjectName",
        required: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "Version",
        required: true,
        type: {
          name: "String",
        },
      },
      nbf: {
        serializedName: "NBF",
        required: true,
        type: {
          name: "Number",
        },
      },
      exp: {
        serializedName: "EXP",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const KeyVaultKeyNewVersionCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "KeyVaultKeyNewVersionCreatedEventData",
      modelProperties: {
        id: {
          serializedName: "Id",
          required: true,
          type: {
            name: "String",
          },
        },
        vaultName: {
          serializedName: "VaultName",
          required: true,
          type: {
            name: "String",
          },
        },
        objectType: {
          serializedName: "ObjectType",
          required: true,
          type: {
            name: "String",
          },
        },
        objectName: {
          serializedName: "ObjectName",
          required: true,
          type: {
            name: "String",
          },
        },
        version: {
          serializedName: "Version",
          required: true,
          type: {
            name: "String",
          },
        },
        nbf: {
          serializedName: "NBF",
          required: true,
          type: {
            name: "Number",
          },
        },
        exp: {
          serializedName: "EXP",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const KeyVaultKeyNearExpiryEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "KeyVaultKeyNearExpiryEventData",
    modelProperties: {
      id: {
        serializedName: "Id",
        required: true,
        type: {
          name: "String",
        },
      },
      vaultName: {
        serializedName: "VaultName",
        required: true,
        type: {
          name: "String",
        },
      },
      objectType: {
        serializedName: "ObjectType",
        required: true,
        type: {
          name: "String",
        },
      },
      objectName: {
        serializedName: "ObjectName",
        required: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "Version",
        required: true,
        type: {
          name: "String",
        },
      },
      nbf: {
        serializedName: "NBF",
        required: true,
        type: {
          name: "Number",
        },
      },
      exp: {
        serializedName: "EXP",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const KeyVaultKeyExpiredEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "KeyVaultKeyExpiredEventData",
    modelProperties: {
      id: {
        serializedName: "Id",
        required: true,
        type: {
          name: "String",
        },
      },
      vaultName: {
        serializedName: "VaultName",
        required: true,
        type: {
          name: "String",
        },
      },
      objectType: {
        serializedName: "ObjectType",
        required: true,
        type: {
          name: "String",
        },
      },
      objectName: {
        serializedName: "ObjectName",
        required: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "Version",
        required: true,
        type: {
          name: "String",
        },
      },
      nbf: {
        serializedName: "NBF",
        required: true,
        type: {
          name: "Number",
        },
      },
      exp: {
        serializedName: "EXP",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const KeyVaultSecretNewVersionCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "KeyVaultSecretNewVersionCreatedEventData",
      modelProperties: {
        id: {
          serializedName: "Id",
          required: true,
          type: {
            name: "String",
          },
        },
        vaultName: {
          serializedName: "VaultName",
          required: true,
          type: {
            name: "String",
          },
        },
        objectType: {
          serializedName: "ObjectType",
          required: true,
          type: {
            name: "String",
          },
        },
        objectName: {
          serializedName: "ObjectName",
          required: true,
          type: {
            name: "String",
          },
        },
        version: {
          serializedName: "Version",
          required: true,
          type: {
            name: "String",
          },
        },
        nbf: {
          serializedName: "NBF",
          required: true,
          type: {
            name: "Number",
          },
        },
        exp: {
          serializedName: "EXP",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const KeyVaultSecretNearExpiryEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "KeyVaultSecretNearExpiryEventData",
    modelProperties: {
      id: {
        serializedName: "Id",
        required: true,
        type: {
          name: "String",
        },
      },
      vaultName: {
        serializedName: "VaultName",
        required: true,
        type: {
          name: "String",
        },
      },
      objectType: {
        serializedName: "ObjectType",
        required: true,
        type: {
          name: "String",
        },
      },
      objectName: {
        serializedName: "ObjectName",
        required: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "Version",
        required: true,
        type: {
          name: "String",
        },
      },
      nbf: {
        serializedName: "NBF",
        required: true,
        type: {
          name: "Number",
        },
      },
      exp: {
        serializedName: "EXP",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const KeyVaultSecretExpiredEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "KeyVaultSecretExpiredEventData",
    modelProperties: {
      id: {
        serializedName: "Id",
        required: true,
        type: {
          name: "String",
        },
      },
      vaultName: {
        serializedName: "VaultName",
        required: true,
        type: {
          name: "String",
        },
      },
      objectType: {
        serializedName: "ObjectType",
        required: true,
        type: {
          name: "String",
        },
      },
      objectName: {
        serializedName: "ObjectName",
        required: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "Version",
        required: true,
        type: {
          name: "String",
        },
      },
      nbf: {
        serializedName: "NBF",
        required: true,
        type: {
          name: "Number",
        },
      },
      exp: {
        serializedName: "EXP",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const KeyVaultAccessPolicyChangedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "KeyVaultAccessPolicyChangedEventData",
      modelProperties: {
        id: {
          serializedName: "Id",
          required: true,
          type: {
            name: "String",
          },
        },
        vaultName: {
          serializedName: "VaultName",
          required: true,
          type: {
            name: "String",
          },
        },
        objectType: {
          serializedName: "ObjectType",
          required: true,
          type: {
            name: "String",
          },
        },
        objectName: {
          serializedName: "ObjectName",
          required: true,
          type: {
            name: "String",
          },
        },
        version: {
          serializedName: "Version",
          required: true,
          type: {
            name: "String",
          },
        },
        nbf: {
          serializedName: "NBF",
          required: true,
          type: {
            name: "Number",
          },
        },
        exp: {
          serializedName: "EXP",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const MachineLearningServicesModelRegisteredEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MachineLearningServicesModelRegisteredEventData",
      modelProperties: {
        modelName: {
          serializedName: "modelName",
          required: true,
          type: {
            name: "String",
          },
        },
        modelVersion: {
          serializedName: "modelVersion",
          required: true,
          type: {
            name: "String",
          },
        },
        modelTags: {
          serializedName: "modelTags",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "any" } },
          },
        },
        modelProperties: {
          serializedName: "modelProperties",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "any" } },
          },
        },
      },
    },
  };

export const MachineLearningServicesModelDeployedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MachineLearningServicesModelDeployedEventData",
      modelProperties: {
        serviceName: {
          serializedName: "serviceName",
          required: true,
          type: {
            name: "String",
          },
        },
        serviceComputeType: {
          serializedName: "serviceComputeType",
          required: true,
          type: {
            name: "String",
          },
        },
        modelIds: {
          serializedName: "modelIds",
          required: true,
          type: {
            name: "String",
          },
        },
        serviceTags: {
          serializedName: "serviceTags",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "any" } },
          },
        },
        serviceProperties: {
          serializedName: "serviceProperties",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "any" } },
          },
        },
      },
    },
  };

export const MachineLearningServicesRunCompletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MachineLearningServicesRunCompletedEventData",
      modelProperties: {
        experimentId: {
          serializedName: "experimentId",
          required: true,
          type: {
            name: "String",
          },
        },
        experimentName: {
          serializedName: "experimentName",
          required: true,
          type: {
            name: "String",
          },
        },
        runId: {
          serializedName: "runId",
          required: true,
          type: {
            name: "String",
          },
        },
        runType: {
          serializedName: "runType",
          required: true,
          type: {
            name: "String",
          },
        },
        runTags: {
          serializedName: "runTags",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "any" } },
          },
        },
        runProperties: {
          serializedName: "runProperties",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "any" } },
          },
        },
      },
    },
  };

export const MachineLearningServicesDatasetDriftDetectedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MachineLearningServicesDatasetDriftDetectedEventData",
      modelProperties: {
        dataDriftId: {
          serializedName: "dataDriftId",
          required: true,
          type: {
            name: "String",
          },
        },
        dataDriftName: {
          serializedName: "dataDriftName",
          required: true,
          type: {
            name: "String",
          },
        },
        runId: {
          serializedName: "runId",
          required: true,
          type: {
            name: "String",
          },
        },
        baseDatasetId: {
          serializedName: "baseDatasetId",
          required: true,
          type: {
            name: "String",
          },
        },
        targetDatasetId: {
          serializedName: "targetDatasetId",
          required: true,
          type: {
            name: "String",
          },
        },
        driftCoefficient: {
          serializedName: "driftCoefficient",
          required: true,
          type: {
            name: "Number",
          },
        },
        startTime: {
          serializedName: "startTime",
          required: true,
          type: {
            name: "String",
          },
        },
        endTime: {
          serializedName: "endTime",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MachineLearningServicesRunStatusChangedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "MachineLearningServicesRunStatusChangedEventData",
      modelProperties: {
        experimentId: {
          serializedName: "experimentId",
          required: true,
          type: {
            name: "String",
          },
        },
        experimentName: {
          serializedName: "experimentName",
          required: true,
          type: {
            name: "String",
          },
        },
        runId: {
          serializedName: "runId",
          required: true,
          type: {
            name: "String",
          },
        },
        runType: {
          serializedName: "runType",
          required: true,
          type: {
            name: "String",
          },
        },
        runTags: {
          serializedName: "runTags",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "any" } },
          },
        },
        runProperties: {
          serializedName: "runProperties",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "any" } },
          },
        },
        runStatus: {
          serializedName: "runStatus",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const RedisPatchingCompletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "RedisPatchingCompletedEventData",
    modelProperties: {
      timestamp: {
        serializedName: "timestamp",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const RedisScalingCompletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "RedisScalingCompletedEventData",
    modelProperties: {
      timestamp: {
        serializedName: "timestamp",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const RedisExportRDBCompletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "RedisExportRDBCompletedEventData",
    modelProperties: {
      timestamp: {
        serializedName: "timestamp",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const RedisImportRDBCompletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "RedisImportRDBCompletedEventData",
    modelProperties: {
      timestamp: {
        serializedName: "timestamp",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebAppUpdatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "WebAppUpdatedEventData",
    modelProperties: {
      appEventTypeDetail: {
        serializedName: "appEventTypeDetail",
        type: {
          name: "Composite",
          className: "AppEventTypeDetail",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      correlationRequestId: {
        serializedName: "correlationRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      address: {
        serializedName: "address",
        required: true,
        type: {
          name: "String",
        },
      },
      verb: {
        serializedName: "verb",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AppEventTypeDetail: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AppEventTypeDetail",
    modelProperties: {
      action: {
        serializedName: "action",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebBackupOperationStartedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "WebBackupOperationStartedEventData",
    modelProperties: {
      appEventTypeDetail: {
        serializedName: "appEventTypeDetail",
        type: {
          name: "Composite",
          className: "AppEventTypeDetail",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      correlationRequestId: {
        serializedName: "correlationRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      address: {
        serializedName: "address",
        required: true,
        type: {
          name: "String",
        },
      },
      verb: {
        serializedName: "verb",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebBackupOperationCompletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "WebBackupOperationCompletedEventData",
      modelProperties: {
        appEventTypeDetail: {
          serializedName: "appEventTypeDetail",
          type: {
            name: "Composite",
            className: "AppEventTypeDetail",
          },
        },
        name: {
          serializedName: "name",
          required: true,
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "clientRequestId",
          required: true,
          type: {
            name: "String",
          },
        },
        correlationRequestId: {
          serializedName: "correlationRequestId",
          required: true,
          type: {
            name: "String",
          },
        },
        requestId: {
          serializedName: "requestId",
          required: true,
          type: {
            name: "String",
          },
        },
        address: {
          serializedName: "address",
          required: true,
          type: {
            name: "String",
          },
        },
        verb: {
          serializedName: "verb",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const WebBackupOperationFailedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "WebBackupOperationFailedEventData",
    modelProperties: {
      appEventTypeDetail: {
        serializedName: "appEventTypeDetail",
        type: {
          name: "Composite",
          className: "AppEventTypeDetail",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      correlationRequestId: {
        serializedName: "correlationRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      address: {
        serializedName: "address",
        required: true,
        type: {
          name: "String",
        },
      },
      verb: {
        serializedName: "verb",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebRestoreOperationStartedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "WebRestoreOperationStartedEventData",
    modelProperties: {
      appEventTypeDetail: {
        serializedName: "appEventTypeDetail",
        type: {
          name: "Composite",
          className: "AppEventTypeDetail",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      correlationRequestId: {
        serializedName: "correlationRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      address: {
        serializedName: "address",
        required: true,
        type: {
          name: "String",
        },
      },
      verb: {
        serializedName: "verb",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebRestoreOperationCompletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "WebRestoreOperationCompletedEventData",
      modelProperties: {
        appEventTypeDetail: {
          serializedName: "appEventTypeDetail",
          type: {
            name: "Composite",
            className: "AppEventTypeDetail",
          },
        },
        name: {
          serializedName: "name",
          required: true,
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "clientRequestId",
          required: true,
          type: {
            name: "String",
          },
        },
        correlationRequestId: {
          serializedName: "correlationRequestId",
          required: true,
          type: {
            name: "String",
          },
        },
        requestId: {
          serializedName: "requestId",
          required: true,
          type: {
            name: "String",
          },
        },
        address: {
          serializedName: "address",
          required: true,
          type: {
            name: "String",
          },
        },
        verb: {
          serializedName: "verb",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const WebRestoreOperationFailedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "WebRestoreOperationFailedEventData",
    modelProperties: {
      appEventTypeDetail: {
        serializedName: "appEventTypeDetail",
        type: {
          name: "Composite",
          className: "AppEventTypeDetail",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      correlationRequestId: {
        serializedName: "correlationRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      address: {
        serializedName: "address",
        required: true,
        type: {
          name: "String",
        },
      },
      verb: {
        serializedName: "verb",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebSlotSwapStartedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "WebSlotSwapStartedEventData",
    modelProperties: {
      appEventTypeDetail: {
        serializedName: "appEventTypeDetail",
        type: {
          name: "Composite",
          className: "AppEventTypeDetail",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      correlationRequestId: {
        serializedName: "correlationRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      address: {
        serializedName: "address",
        required: true,
        type: {
          name: "String",
        },
      },
      verb: {
        serializedName: "verb",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebSlotSwapCompletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "WebSlotSwapCompletedEventData",
    modelProperties: {
      appEventTypeDetail: {
        serializedName: "appEventTypeDetail",
        type: {
          name: "Composite",
          className: "AppEventTypeDetail",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      correlationRequestId: {
        serializedName: "correlationRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      address: {
        serializedName: "address",
        required: true,
        type: {
          name: "String",
        },
      },
      verb: {
        serializedName: "verb",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebSlotSwapFailedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "WebSlotSwapFailedEventData",
    modelProperties: {
      appEventTypeDetail: {
        serializedName: "appEventTypeDetail",
        type: {
          name: "Composite",
          className: "AppEventTypeDetail",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      correlationRequestId: {
        serializedName: "correlationRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      address: {
        serializedName: "address",
        required: true,
        type: {
          name: "String",
        },
      },
      verb: {
        serializedName: "verb",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebSlotSwapWithPreviewStartedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "WebSlotSwapWithPreviewStartedEventData",
      modelProperties: {
        appEventTypeDetail: {
          serializedName: "appEventTypeDetail",
          type: {
            name: "Composite",
            className: "AppEventTypeDetail",
          },
        },
        name: {
          serializedName: "name",
          required: true,
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "clientRequestId",
          required: true,
          type: {
            name: "String",
          },
        },
        correlationRequestId: {
          serializedName: "correlationRequestId",
          required: true,
          type: {
            name: "String",
          },
        },
        requestId: {
          serializedName: "requestId",
          required: true,
          type: {
            name: "String",
          },
        },
        address: {
          serializedName: "address",
          required: true,
          type: {
            name: "String",
          },
        },
        verb: {
          serializedName: "verb",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const WebSlotSwapWithPreviewCancelledEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "WebSlotSwapWithPreviewCancelledEventData",
      modelProperties: {
        appEventTypeDetail: {
          serializedName: "appEventTypeDetail",
          type: {
            name: "Composite",
            className: "AppEventTypeDetail",
          },
        },
        name: {
          serializedName: "name",
          required: true,
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "clientRequestId",
          required: true,
          type: {
            name: "String",
          },
        },
        correlationRequestId: {
          serializedName: "correlationRequestId",
          required: true,
          type: {
            name: "String",
          },
        },
        requestId: {
          serializedName: "requestId",
          required: true,
          type: {
            name: "String",
          },
        },
        address: {
          serializedName: "address",
          required: true,
          type: {
            name: "String",
          },
        },
        verb: {
          serializedName: "verb",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const WebAppServicePlanUpdatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "WebAppServicePlanUpdatedEventData",
    modelProperties: {
      appServicePlanEventTypeDetail: {
        serializedName: "appServicePlanEventTypeDetail",
        type: {
          name: "Composite",
          className: "AppServicePlanEventTypeDetail",
        },
      },
      sku: {
        serializedName: "sku",
        type: {
          name: "Composite",
          className: "WebAppServicePlanUpdatedEventDataSku",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "clientRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      correlationRequestId: {
        serializedName: "correlationRequestId",
        required: true,
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "requestId",
        required: true,
        type: {
          name: "String",
        },
      },
      address: {
        serializedName: "address",
        required: true,
        type: {
          name: "String",
        },
      },
      verb: {
        serializedName: "verb",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AppServicePlanEventTypeDetail: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AppServicePlanEventTypeDetail",
    modelProperties: {
      stampKind: {
        serializedName: "stampKind",
        required: true,
        type: {
          name: "String",
        },
      },
      action: {
        serializedName: "action",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebAppServicePlanUpdatedEventDataSku: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "WebAppServicePlanUpdatedEventDataSku",
      modelProperties: {
        name: {
          serializedName: "name",
          type: {
            name: "String",
          },
        },
        tier: {
          serializedName: "Tier",
          type: {
            name: "String",
          },
        },
        size: {
          serializedName: "Size",
          type: {
            name: "String",
          },
        },
        family: {
          serializedName: "Family",
          type: {
            name: "String",
          },
        },
        capacity: {
          serializedName: "Capacity",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsIncomingCallEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsIncomingCallEventData",
    modelProperties: {
      toCommunicationIdentifier: {
        serializedName: "to",
        type: {
          name: "Composite",
          className: "CommunicationIdentifierModel",
        },
      },
      fromCommunicationIdentifier: {
        serializedName: "from",
        type: {
          name: "Composite",
          className: "CommunicationIdentifierModel",
        },
      },
      serverCallId: {
        serializedName: "serverCallId",
        required: true,
        type: {
          name: "String",
        },
      },
      callerDisplayName: {
        serializedName: "callerDisplayName",
        required: true,
        type: {
          name: "String",
        },
      },
      customContext: {
        serializedName: "customContext",
        type: {
          name: "Composite",
          className: "AcsIncomingCallCustomContext",
        },
      },
      incomingCallContext: {
        serializedName: "incomingCallContext",
        required: true,
        type: {
          name: "String",
        },
      },
      onBehalfOfCallee: {
        serializedName: "onBehalfOfCallee",
        type: {
          name: "Composite",
          className: "CommunicationIdentifierModel",
        },
      },
      correlationId: {
        serializedName: "correlationId",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CommunicationIdentifierModel: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CommunicationIdentifierModel",
    modelProperties: {
      kind: {
        serializedName: "kind",
        type: {
          name: "String",
        },
      },
      rawId: {
        serializedName: "rawId",
        required: true,
        type: {
          name: "String",
        },
      },
      communicationUser: {
        serializedName: "communicationUser",
        type: {
          name: "Composite",
          className: "CommunicationUserIdentifierModel",
        },
      },
      phoneNumber: {
        serializedName: "phoneNumber",
        type: {
          name: "Composite",
          className: "PhoneNumberIdentifierModel",
        },
      },
      microsoftTeamsUser: {
        serializedName: "microsoftTeamsUser",
        type: {
          name: "Composite",
          className: "MicrosoftTeamsUserIdentifierModel",
        },
      },
      microsoftTeamsApp: {
        serializedName: "microsoftTeamsApp",
        type: {
          name: "Composite",
          className: "MicrosoftTeamsAppIdentifierModel",
        },
      },
    },
  },
};

export const CommunicationUserIdentifierModel: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CommunicationUserIdentifierModel",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PhoneNumberIdentifierModel: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PhoneNumberIdentifierModel",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MicrosoftTeamsUserIdentifierModel: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MicrosoftTeamsUserIdentifierModel",
    modelProperties: {
      userId: {
        serializedName: "userId",
        required: true,
        type: {
          name: "String",
        },
      },
      isAnonymous: {
        serializedName: "isAnonymous",
        type: {
          name: "Boolean",
        },
      },
      cloud: {
        serializedName: "cloud",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MicrosoftTeamsAppIdentifierModel: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MicrosoftTeamsAppIdentifierModel",
    modelProperties: {
      appId: {
        serializedName: "appId",
        required: true,
        type: {
          name: "String",
        },
      },
      cloud: {
        serializedName: "cloud",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsIncomingCallCustomContext: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsIncomingCallCustomContext",
    modelProperties: {
      sipHeaders: {
        serializedName: "sipHeaders",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      voipHeaders: {
        serializedName: "voipHeaders",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const AcsUserDisconnectedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsUserDisconnectedEventData",
    modelProperties: {
      userCommunicationIdentifier: {
        serializedName: "userCommunicationIdentifier",
        type: {
          name: "Composite",
          className: "CommunicationIdentifierModel",
        },
      },
    },
  },
};

export const AcsRouterEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterEventData",
    modelProperties: {
      jobId: {
        serializedName: "jobId",
        required: true,
        type: {
          name: "String",
        },
      },
      channelReference: {
        serializedName: "channelReference",
        required: true,
        type: {
          name: "String",
        },
      },
      channelId: {
        serializedName: "channelId",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsRouterCommunicationError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterCommunicationError",
    modelProperties: {
      code: {
        serializedName: "code",
        required: true,
        type: {
          name: "String",
        },
      },
      message: {
        serializedName: "message",
        required: true,
        type: {
          name: "String",
        },
      },
      target: {
        serializedName: "target",
        required: true,
        type: {
          name: "String",
        },
      },
      innererror: {
        serializedName: "innererror",
        type: {
          name: "Composite",
          className: "AcsRouterCommunicationError",
        },
      },
      details: {
        serializedName: "details",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AcsRouterCommunicationError",
            },
          },
        },
      },
    },
  },
};

export const AcsRouterQueueDetails: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterQueueDetails",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      labels: {
        serializedName: "labels",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const AcsRouterWorkerSelector: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterWorkerSelector",
    modelProperties: {
      key: {
        serializedName: "key",
        required: true,
        type: {
          name: "String",
        },
      },
      labelOperator: {
        serializedName: "labelOperator",
        required: true,
        type: {
          name: "String",
        },
      },
      labelValue: {
        serializedName: "value",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
      ttlSeconds: {
        serializedName: "ttlSeconds",
        required: true,
        type: {
          name: "Number",
        },
      },
      state: {
        serializedName: "state",
        required: true,
        type: {
          name: "String",
        },
      },
      expirationTime: {
        serializedName: "expirationTime",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsRouterWorkerDeregisteredEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsRouterWorkerDeregisteredEventData",
      modelProperties: {
        workerId: {
          serializedName: "workerId",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsRouterWorkerRegisteredEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterWorkerRegisteredEventData",
    modelProperties: {
      workerId: {
        serializedName: "workerId",
        required: true,
        type: {
          name: "String",
        },
      },
      queueAssignments: {
        serializedName: "queueAssignments",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AcsRouterQueueDetails",
            },
          },
        },
      },
      channelConfigurations: {
        serializedName: "channelConfigurations",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AcsRouterChannelConfiguration",
            },
          },
        },
      },
      totalCapacity: {
        serializedName: "totalCapacity",
        required: true,
        type: {
          name: "Number",
        },
      },
      labels: {
        serializedName: "labels",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      tags: {
        serializedName: "tags",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const AcsRouterChannelConfiguration: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterChannelConfiguration",
    modelProperties: {
      channelId: {
        serializedName: "channelId",
        required: true,
        type: {
          name: "String",
        },
      },
      capacityCostPerJob: {
        serializedName: "capacityCostPerJob",
        required: true,
        type: {
          name: "Number",
        },
      },
      maxNumberOfJobs: {
        serializedName: "maxNumberOfJobs",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const AcsRouterWorkerUpdatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterWorkerUpdatedEventData",
    modelProperties: {
      workerId: {
        serializedName: "workerId",
        required: true,
        type: {
          name: "String",
        },
      },
      queueAssignments: {
        serializedName: "queueAssignments",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AcsRouterQueueDetails",
            },
          },
        },
      },
      channelConfigurations: {
        serializedName: "channelConfigurations",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AcsRouterChannelConfiguration",
            },
          },
        },
      },
      totalCapacity: {
        serializedName: "totalCapacity",
        required: true,
        type: {
          name: "Number",
        },
      },
      labels: {
        serializedName: "labels",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      tags: {
        serializedName: "tags",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      updatedWorkerProperties: {
        serializedName: "updatedWorkerProperties",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const AcsChatEventBase: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatEventBase",
    modelProperties: {
      recipientCommunicationIdentifier: {
        serializedName: "recipientCommunicationIdentifier",
        type: {
          name: "Composite",
          className: "CommunicationIdentifierModel",
        },
      },
      transactionId: {
        serializedName: "transactionId",
        required: true,
        type: {
          name: "String",
        },
      },
      threadId: {
        serializedName: "threadId",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsChatEventInThreadBase: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatEventInThreadBase",
    modelProperties: {
      transactionId: {
        serializedName: "transactionId",
        required: true,
        type: {
          name: "String",
        },
      },
      threadId: {
        serializedName: "threadId",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsChatThreadParticipant: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatThreadParticipant",
    modelProperties: {
      displayName: {
        serializedName: "displayName",
        required: true,
        type: {
          name: "String",
        },
      },
      participantCommunicationIdentifier: {
        serializedName: "participantCommunicationIdentifier",
        type: {
          name: "Composite",
          className: "CommunicationIdentifierModel",
        },
      },
      metadata: {
        serializedName: "metadata",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const AcsSmsDeliveryAttempt: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsSmsDeliveryAttempt",
    modelProperties: {
      timestamp: {
        serializedName: "timestamp",
        required: true,
        type: {
          name: "String",
        },
      },
      segmentsSucceeded: {
        serializedName: "segmentsSucceeded",
        required: true,
        type: {
          name: "Number",
        },
      },
      segmentsFailed: {
        serializedName: "segmentsFailed",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const AcsSmsEventBase: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsSmsEventBase",
    modelProperties: {
      messageId: {
        serializedName: "messageId",
        required: true,
        type: {
          name: "String",
        },
      },
      from: {
        serializedName: "from",
        required: true,
        type: {
          name: "String",
        },
      },
      to: {
        serializedName: "to",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsRecordingFileStatusUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsRecordingFileStatusUpdatedEventData",
      modelProperties: {
        recordingStorageInfo: {
          serializedName: "recordingStorageInfo",
          type: {
            name: "Composite",
            className: "AcsRecordingStorageInfo",
          },
        },
        recordingStartTime: {
          serializedName: "recordingStartTime",
          required: true,
          type: {
            name: "String",
          },
        },
        recordingDurationMs: {
          serializedName: "recordingDurationMs",
          required: true,
          type: {
            name: "Number",
          },
        },
        recordingContentType: {
          serializedName: "recordingContentType",
          required: true,
          type: {
            name: "String",
          },
        },
        recordingChannelType: {
          serializedName: "recordingChannelType",
          required: true,
          type: {
            name: "String",
          },
        },
        recordingFormatType: {
          serializedName: "recordingFormatType",
          required: true,
          type: {
            name: "String",
          },
        },
        sessionEndReason: {
          serializedName: "sessionEndReason",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsRecordingStorageInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRecordingStorageInfo",
    modelProperties: {
      recordingChunks: {
        serializedName: "recordingChunks",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AcsRecordingChunkInfo",
            },
          },
        },
      },
    },
  },
};

export const AcsRecordingChunkInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRecordingChunkInfo",
    modelProperties: {
      documentId: {
        serializedName: "documentId",
        required: true,
        type: {
          name: "String",
        },
      },
      index: {
        serializedName: "index",
        required: true,
        type: {
          name: "Number",
        },
      },
      endReason: {
        serializedName: "endReason",
        required: true,
        type: {
          name: "String",
        },
      },
      metadataLocation: {
        serializedName: "metadataLocation",
        required: true,
        type: {
          name: "String",
        },
      },
      contentLocation: {
        serializedName: "contentLocation",
        required: true,
        type: {
          name: "String",
        },
      },
      deleteLocation: {
        serializedName: "deleteLocation",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsEmailDeliveryReportReceivedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsEmailDeliveryReportReceivedEventData",
      modelProperties: {
        sender: {
          serializedName: "sender",
          required: true,
          type: {
            name: "String",
          },
        },
        recipient: {
          serializedName: "recipient",
          required: true,
          type: {
            name: "String",
          },
        },
        internetMessageId: {
          serializedName: "internetMessageId",
          required: true,
          type: {
            name: "String",
          },
        },
        messageId: {
          serializedName: "messageId",
          required: true,
          type: {
            name: "String",
          },
        },
        status: {
          serializedName: "status",
          required: true,
          type: {
            name: "String",
          },
        },
        deliveryStatusDetails: {
          serializedName: "deliveryStatusDetails",
          type: {
            name: "Composite",
            className: "AcsEmailDeliveryReportStatusDetails",
          },
        },
        deliveryAttemptTimestamp: {
          serializedName: "deliveryAttemptTimestamp",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsEmailDeliveryReportStatusDetails: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsEmailDeliveryReportStatusDetails",
    modelProperties: {
      recipientMailServerHostName: {
        serializedName: "recipientMailServerHostName",
        required: true,
        type: {
          name: "String",
        },
      },
      statusMessage: {
        serializedName: "statusMessage",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsEmailEngagementTrackingReportReceivedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsEmailEngagementTrackingReportReceivedEventData",
      modelProperties: {
        sender: {
          serializedName: "sender",
          required: true,
          type: {
            name: "String",
          },
        },
        recipient: {
          serializedName: "recipient",
          required: true,
          type: {
            name: "String",
          },
        },
        messageId: {
          serializedName: "messageId",
          required: true,
          type: {
            name: "String",
          },
        },
        userActionTimestamp: {
          serializedName: "userActionTimestamp",
          required: true,
          type: {
            name: "String",
          },
        },
        engagementContext: {
          serializedName: "engagementContext",
          required: true,
          type: {
            name: "String",
          },
        },
        userAgent: {
          serializedName: "userAgent",
          required: true,
          type: {
            name: "String",
          },
        },
        engagement: {
          serializedName: "engagementType",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsMessageMediaContent: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsMessageMediaContent",
    modelProperties: {
      mimeType: {
        serializedName: "mimeType",
        required: true,
        type: {
          name: "String",
        },
      },
      mediaId: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
      fileName: {
        serializedName: "fileName",
        type: {
          name: "String",
        },
      },
      caption: {
        serializedName: "caption",
        type: {
          name: "String",
        },
      },
      animated: {
        serializedName: "animated",
        type: {
          name: "Boolean",
        },
      },
    },
  },
};

export const AcsMessageReactionContent: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsMessageReactionContent",
    modelProperties: {
      messageId: {
        serializedName: "messageId",
        required: true,
        type: {
          name: "String",
        },
      },
      emoji: {
        serializedName: "emoji",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsMessageContext: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsMessageContext",
    modelProperties: {
      from: {
        serializedName: "from",
        required: true,
        type: {
          name: "String",
        },
      },
      messageId: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsMessageButtonContent: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsMessageButtonContent",
    modelProperties: {
      text: {
        serializedName: "text",
        required: true,
        type: {
          name: "String",
        },
      },
      payload: {
        serializedName: "payload",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsMessageInteractiveContent: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsMessageInteractiveContent",
    modelProperties: {
      replyKind: {
        serializedName: "type",
        required: true,
        type: {
          name: "String",
        },
      },
      buttonReply: {
        serializedName: "buttonReply",
        type: {
          name: "Composite",
          className: "AcsMessageInteractiveButtonReplyContent",
        },
      },
      listReply: {
        serializedName: "listReply",
        type: {
          name: "Composite",
          className: "AcsMessageInteractiveListReplyContent",
        },
      },
    },
  },
};

export const AcsMessageInteractiveButtonReplyContent: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsMessageInteractiveButtonReplyContent",
      modelProperties: {
        buttonId: {
          serializedName: "id",
          required: true,
          type: {
            name: "String",
          },
        },
        title: {
          serializedName: "title",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsMessageInteractiveListReplyContent: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsMessageInteractiveListReplyContent",
      modelProperties: {
        listItemId: {
          serializedName: "id",
          required: true,
          type: {
            name: "String",
          },
        },
        title: {
          serializedName: "title",
          required: true,
          type: {
            name: "String",
          },
        },
        description: {
          serializedName: "description",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsMessageEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsMessageEventData",
    modelProperties: {
      from: {
        serializedName: "from",
        required: true,
        type: {
          name: "String",
        },
      },
      to: {
        serializedName: "to",
        required: true,
        type: {
          name: "String",
        },
      },
      receivedTimestamp: {
        serializedName: "receivedTimestamp",
        type: {
          name: "String",
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "AcsMessageChannelEventError",
        },
      },
    },
  },
};

export const AcsMessageChannelEventError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsMessageChannelEventError",
    modelProperties: {
      channelCode: {
        serializedName: "channelCode",
        required: true,
        type: {
          name: "String",
        },
      },
      channelMessage: {
        serializedName: "channelMessage",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PolicyInsightsPolicyStateCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "PolicyInsightsPolicyStateCreatedEventData",
      modelProperties: {
        timestamp: {
          serializedName: "timestamp",
          required: true,
          type: {
            name: "String",
          },
        },
        policyAssignmentId: {
          serializedName: "policyAssignmentId",
          required: true,
          type: {
            name: "String",
          },
        },
        policyDefinitionId: {
          serializedName: "policyDefinitionId",
          required: true,
          type: {
            name: "String",
          },
        },
        policyDefinitionReferenceId: {
          serializedName: "policyDefinitionReferenceId",
          required: true,
          type: {
            name: "String",
          },
        },
        complianceState: {
          serializedName: "complianceState",
          required: true,
          type: {
            name: "String",
          },
        },
        subscriptionId: {
          serializedName: "subscriptionId",
          required: true,
          type: {
            name: "String",
          },
        },
        complianceReasonCode: {
          serializedName: "complianceReasonCode",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const PolicyInsightsPolicyStateChangedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "PolicyInsightsPolicyStateChangedEventData",
      modelProperties: {
        timestamp: {
          serializedName: "timestamp",
          required: true,
          type: {
            name: "String",
          },
        },
        policyAssignmentId: {
          serializedName: "policyAssignmentId",
          required: true,
          type: {
            name: "String",
          },
        },
        policyDefinitionId: {
          serializedName: "policyDefinitionId",
          required: true,
          type: {
            name: "String",
          },
        },
        policyDefinitionReferenceId: {
          serializedName: "policyDefinitionReferenceId",
          required: true,
          type: {
            name: "String",
          },
        },
        complianceState: {
          serializedName: "complianceState",
          required: true,
          type: {
            name: "String",
          },
        },
        subscriptionId: {
          serializedName: "subscriptionId",
          required: true,
          type: {
            name: "String",
          },
        },
        complianceReasonCode: {
          serializedName: "complianceReasonCode",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const PolicyInsightsPolicyStateDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "PolicyInsightsPolicyStateDeletedEventData",
      modelProperties: {
        timestamp: {
          serializedName: "timestamp",
          required: true,
          type: {
            name: "String",
          },
        },
        policyAssignmentId: {
          serializedName: "policyAssignmentId",
          required: true,
          type: {
            name: "String",
          },
        },
        policyDefinitionId: {
          serializedName: "policyDefinitionId",
          required: true,
          type: {
            name: "String",
          },
        },
        policyDefinitionReferenceId: {
          serializedName: "policyDefinitionReferenceId",
          required: true,
          type: {
            name: "String",
          },
        },
        complianceState: {
          serializedName: "complianceState",
          required: true,
          type: {
            name: "String",
          },
        },
        subscriptionId: {
          serializedName: "subscriptionId",
          required: true,
          type: {
            name: "String",
          },
        },
        complianceReasonCode: {
          serializedName: "complianceReasonCode",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ContainerServiceNewKubernetesVersionAvailableEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerServiceNewKubernetesVersionAvailableEventData",
      modelProperties: {
        latestSupportedKubernetesVersion: {
          serializedName: "latestSupportedKubernetesVersion",
          required: true,
          type: {
            name: "String",
          },
        },
        latestStableKubernetesVersion: {
          serializedName: "latestStableKubernetesVersion",
          required: true,
          type: {
            name: "String",
          },
        },
        lowestMinorKubernetesVersion: {
          serializedName: "lowestMinorKubernetesVersion",
          required: true,
          type: {
            name: "String",
          },
        },
        latestPreviewKubernetesVersion: {
          serializedName: "latestPreviewKubernetesVersion",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ContainerServiceClusterSupportEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerServiceClusterSupportEventData",
      modelProperties: {
        kubernetesVersion: {
          serializedName: "kubernetesVersion",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ContainerServiceNodePoolRollingEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerServiceNodePoolRollingEventData",
      modelProperties: {
        nodePoolName: {
          serializedName: "nodePoolName",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementUserCreatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiManagementUserCreatedEventData",
    modelProperties: {
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ApiManagementUserUpdatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiManagementUserUpdatedEventData",
    modelProperties: {
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ApiManagementUserDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiManagementUserDeletedEventData",
    modelProperties: {
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ApiManagementSubscriptionCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementSubscriptionCreatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementSubscriptionUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementSubscriptionUpdatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementSubscriptionDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementSubscriptionDeletedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementProductCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementProductCreatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementProductUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementProductUpdatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementProductDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementProductDeletedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementApiCreatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiManagementApiCreatedEventData",
    modelProperties: {
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ApiManagementApiUpdatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiManagementApiUpdatedEventData",
    modelProperties: {
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ApiManagementApiDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiManagementApiDeletedEventData",
    modelProperties: {
      resourceUri: {
        serializedName: "resourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ApiManagementApiReleaseCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementApiReleaseCreatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementApiReleaseUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementApiReleaseUpdatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementApiReleaseDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementApiReleaseDeletedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementGatewayCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementGatewayCreatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementGatewayUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementGatewayUpdatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementGatewayDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementGatewayDeletedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementGatewayHostnameConfigurationCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementGatewayHostnameConfigurationCreatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementGatewayHostnameConfigurationUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementGatewayHostnameConfigurationUpdatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementGatewayHostnameConfigurationDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementGatewayHostnameConfigurationDeletedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementGatewayCertificateAuthorityCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementGatewayCertificateAuthorityCreatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementGatewayCertificateAuthorityUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementGatewayCertificateAuthorityUpdatedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementGatewayCertificateAuthorityDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementGatewayCertificateAuthorityDeletedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementGatewayApiAddedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementGatewayApiAddedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ApiManagementGatewayApiRemovedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiManagementGatewayApiRemovedEventData",
      modelProperties: {
        resourceUri: {
          serializedName: "resourceUri",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const HealthcareFhirResourceCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "HealthcareFhirResourceCreatedEventData",
      modelProperties: {
        resourceType: {
          serializedName: "resourceType",
          required: true,
          type: {
            name: "String",
          },
        },
        resourceFhirAccount: {
          serializedName: "resourceFhirAccount",
          required: true,
          type: {
            name: "String",
          },
        },
        resourceFhirId: {
          serializedName: "resourceFhirId",
          required: true,
          type: {
            name: "String",
          },
        },
        resourceVersionId: {
          serializedName: "resourceVersionId",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const HealthcareFhirResourceUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "HealthcareFhirResourceUpdatedEventData",
      modelProperties: {
        resourceType: {
          serializedName: "resourceType",
          required: true,
          type: {
            name: "String",
          },
        },
        resourceFhirAccount: {
          serializedName: "resourceFhirAccount",
          required: true,
          type: {
            name: "String",
          },
        },
        resourceFhirId: {
          serializedName: "resourceFhirId",
          required: true,
          type: {
            name: "String",
          },
        },
        resourceVersionId: {
          serializedName: "resourceVersionId",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const HealthcareFhirResourceDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "HealthcareFhirResourceDeletedEventData",
      modelProperties: {
        resourceType: {
          serializedName: "resourceType",
          required: true,
          type: {
            name: "String",
          },
        },
        resourceFhirAccount: {
          serializedName: "resourceFhirAccount",
          required: true,
          type: {
            name: "String",
          },
        },
        resourceFhirId: {
          serializedName: "resourceFhirId",
          required: true,
          type: {
            name: "String",
          },
        },
        resourceVersionId: {
          serializedName: "resourceVersionId",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const HealthcareDicomImageCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "HealthcareDicomImageCreatedEventData",
      modelProperties: {
        partitionName: {
          serializedName: "partitionName",
          required: true,
          type: {
            name: "String",
          },
        },
        imageStudyInstanceUid: {
          serializedName: "imageStudyInstanceUid",
          required: true,
          type: {
            name: "String",
          },
        },
        imageSeriesInstanceUid: {
          serializedName: "imageSeriesInstanceUid",
          required: true,
          type: {
            name: "String",
          },
        },
        imageSopInstanceUid: {
          serializedName: "imageSopInstanceUid",
          required: true,
          type: {
            name: "String",
          },
        },
        serviceHostName: {
          serializedName: "serviceHostName",
          required: true,
          type: {
            name: "String",
          },
        },
        sequenceNumber: {
          serializedName: "sequenceNumber",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const HealthcareDicomImageUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "HealthcareDicomImageUpdatedEventData",
      modelProperties: {
        partitionName: {
          serializedName: "partitionName",
          required: true,
          type: {
            name: "String",
          },
        },
        imageStudyInstanceUid: {
          serializedName: "imageStudyInstanceUid",
          required: true,
          type: {
            name: "String",
          },
        },
        imageSeriesInstanceUid: {
          serializedName: "imageSeriesInstanceUid",
          required: true,
          type: {
            name: "String",
          },
        },
        imageSopInstanceUid: {
          serializedName: "imageSopInstanceUid",
          required: true,
          type: {
            name: "String",
          },
        },
        serviceHostName: {
          serializedName: "serviceHostName",
          required: true,
          type: {
            name: "String",
          },
        },
        sequenceNumber: {
          serializedName: "sequenceNumber",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const HealthcareDicomImageDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "HealthcareDicomImageDeletedEventData",
      modelProperties: {
        partitionName: {
          serializedName: "partitionName",
          required: true,
          type: {
            name: "String",
          },
        },
        imageStudyInstanceUid: {
          serializedName: "imageStudyInstanceUid",
          required: true,
          type: {
            name: "String",
          },
        },
        imageSeriesInstanceUid: {
          serializedName: "imageSeriesInstanceUid",
          required: true,
          type: {
            name: "String",
          },
        },
        imageSopInstanceUid: {
          serializedName: "imageSopInstanceUid",
          required: true,
          type: {
            name: "String",
          },
        },
        serviceHostName: {
          serializedName: "serviceHostName",
          required: true,
          type: {
            name: "String",
          },
        },
        sequenceNumber: {
          serializedName: "sequenceNumber",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const ResourceNotificationsResourceUpdatedDetails: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ResourceNotificationsResourceUpdatedDetails",
      modelProperties: {
        id: {
          serializedName: "id",
          required: true,
          type: {
            name: "String",
          },
        },
        name: {
          serializedName: "name",
          required: true,
          type: {
            name: "String",
          },
        },
        type: {
          serializedName: "type",
          required: true,
          type: {
            name: "String",
          },
        },
        location: {
          serializedName: "location",
          required: true,
          type: {
            name: "String",
          },
        },
        tags: {
          serializedName: "tags",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
        properties: {
          serializedName: "properties",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "any" } },
          },
        },
      },
    },
  };

export const ResourceNotificationsOperationalDetails: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ResourceNotificationsOperationalDetails",
      modelProperties: {
        resourceEventTime: {
          serializedName: "resourceEventTime",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ResourceNotificationsResourceUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ResourceNotificationsResourceUpdatedEventData",
      modelProperties: {
        resourceDetails: {
          serializedName: "resourceInfo",
          type: {
            name: "Composite",
            className: "ResourceNotificationsResourceUpdatedDetails",
          },
        },
        operationalDetails: {
          serializedName: "operationalInfo",
          type: {
            name: "Composite",
            className: "ResourceNotificationsOperationalDetails",
          },
        },
        apiVersion: {
          serializedName: "apiVersion",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ResourceNotificationsResourceDeletedDetails: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ResourceNotificationsResourceDeletedDetails",
      modelProperties: {
        id: {
          serializedName: "id",
          required: true,
          type: {
            name: "String",
          },
        },
        name: {
          serializedName: "name",
          required: true,
          type: {
            name: "String",
          },
        },
        type: {
          serializedName: "type",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ResourceNotificationsResourceDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ResourceNotificationsResourceDeletedEventData",
      modelProperties: {
        resourceDetails: {
          serializedName: "resourceInfo",
          type: {
            name: "Composite",
            className: "ResourceNotificationsResourceDeletedDetails",
          },
        },
        operationalDetails: {
          serializedName: "operationalInfo",
          type: {
            name: "Composite",
            className: "ResourceNotificationsOperationalDetails",
          },
        },
      },
    },
  };

export const AvsPrivateCloudEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsPrivateCloudEventData",
    modelProperties: {
      operationId: {
        serializedName: "operationId",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AvsClusterEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsClusterEventData",
    modelProperties: {
      operationId: {
        serializedName: "operationId",
        required: true,
        type: {
          name: "String",
        },
      },
      addedHostNames: {
        serializedName: "addedHostNames",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      removedHostNames: {
        serializedName: "removedHostNames",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      inMaintenanceHostNames: {
        serializedName: "inMaintenanceHostNames",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const AvsScriptExecutionEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsScriptExecutionEventData",
    modelProperties: {
      operationId: {
        serializedName: "operationId",
        required: true,
        type: {
          name: "String",
        },
      },
      cmdletId: {
        serializedName: "cmdletId",
        required: true,
        type: {
          name: "String",
        },
      },
      output: {
        serializedName: "output",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const ApiCenterApiDefinitionAddedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiCenterApiDefinitionAddedEventData",
      modelProperties: {
        title: {
          serializedName: "title",
          required: true,
          type: {
            name: "String",
          },
        },
        description: {
          serializedName: "description",
          required: true,
          type: {
            name: "String",
          },
        },
        specification: {
          serializedName: "specification",
          type: {
            name: "Composite",
            className: "ApiCenterApiSpecification",
          },
        },
      },
    },
  };

export const ApiCenterApiSpecification: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiCenterApiSpecification",
    modelProperties: {
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "version",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ApiCenterApiDefinitionUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ApiCenterApiDefinitionUpdatedEventData",
      modelProperties: {
        title: {
          serializedName: "title",
          required: true,
          type: {
            name: "String",
          },
        },
        description: {
          serializedName: "description",
          required: true,
          type: {
            name: "String",
          },
        },
        specification: {
          serializedName: "specification",
          type: {
            name: "Composite",
            className: "ApiCenterApiSpecification",
          },
        },
      },
    },
  };

export const EventGridMqttClientCreatedOrUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EventGridMqttClientCreatedOrUpdatedEventData",
      modelProperties: {
        ...EventGridMqttClientEventData.type.modelProperties,
        state: {
          serializedName: "state",
          required: true,
          type: {
            name: "String",
          },
        },
        createdOn: {
          serializedName: "createdOn",
          required: true,
          type: {
            name: "String",
          },
        },
        updatedOn: {
          serializedName: "updatedOn",
          required: true,
          type: {
            name: "String",
          },
        },
        attributes: {
          serializedName: "attributes",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
      },
    },
  };

export const EventGridMqttClientDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventGridMqttClientDeletedEventData",
    modelProperties: {
      ...EventGridMqttClientEventData.type.modelProperties,
    },
  },
};

export const EventGridMqttClientSessionConnectedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EventGridMqttClientSessionConnectedEventData",
      modelProperties: {
        ...EventGridMqttClientEventData.type.modelProperties,
        clientSessionName: {
          serializedName: "clientSessionName",
          required: true,
          type: {
            name: "String",
          },
        },
        sequenceNumber: {
          serializedName: "sequenceNumber",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const EventGridMqttClientSessionDisconnectedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EventGridMqttClientSessionDisconnectedEventData",
      modelProperties: {
        ...EventGridMqttClientEventData.type.modelProperties,
        clientSessionName: {
          serializedName: "clientSessionName",
          required: true,
          type: {
            name: "String",
          },
        },
        sequenceNumber: {
          serializedName: "sequenceNumber",
          required: true,
          type: {
            name: "Number",
          },
        },
        disconnectionReason: {
          serializedName: "disconnectionReason",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const IotHubDeviceCreatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "IotHubDeviceCreatedEventData",
    modelProperties: {
      ...DeviceLifeCycleEvent.type.modelProperties,
    },
  },
};

export const IotHubDeviceDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "IotHubDeviceDeletedEventData",
    modelProperties: {
      ...DeviceLifeCycleEvent.type.modelProperties,
    },
  },
};

export const IotHubDeviceConnectedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "IotHubDeviceConnectedEventData",
    modelProperties: {
      ...DeviceConnectionStateEvent.type.modelProperties,
    },
  },
};

export const IotHubDeviceDisconnectedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "IotHubDeviceDisconnectedEventData",
    modelProperties: {
      ...DeviceConnectionStateEvent.type.modelProperties,
    },
  },
};

export const IotHubDeviceTelemetryEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "IotHubDeviceTelemetryEventData",
    modelProperties: {
      ...DeviceTelemetryEvent.type.modelProperties,
    },
  },
};

export const ContainerRegistryImagePushedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerRegistryImagePushedEventData",
      modelProperties: {
        ...ContainerRegistryEventData.type.modelProperties,
      },
    },
  };

export const ContainerRegistryImageDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerRegistryImageDeletedEventData",
      modelProperties: {
        ...ContainerRegistryEventData.type.modelProperties,
      },
    },
  };

export const ContainerRegistryChartPushedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerRegistryChartPushedEventData",
      modelProperties: {
        ...ContainerRegistryArtifactEventData.type.modelProperties,
      },
    },
  };

export const ContainerRegistryChartDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerRegistryChartDeletedEventData",
      modelProperties: {
        ...ContainerRegistryArtifactEventData.type.modelProperties,
      },
    },
  };

export const MediaJobScheduledEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobScheduledEventData",
    modelProperties: {
      ...MediaJobStateChangeEventData.type.modelProperties,
    },
  },
};

export const MediaJobProcessingEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobProcessingEventData",
    modelProperties: {
      ...MediaJobStateChangeEventData.type.modelProperties,
    },
  },
};

export const MediaJobCancelingEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobCancelingEventData",
    modelProperties: {
      ...MediaJobStateChangeEventData.type.modelProperties,
    },
  },
};

export const MediaJobFinishedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobFinishedEventData",
    modelProperties: {
      ...MediaJobStateChangeEventData.type.modelProperties,
      outputs: {
        serializedName: "outputs",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MediaJobOutput",
            },
          },
        },
      },
    },
  },
};

export const MediaJobCanceledEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobCanceledEventData",
    modelProperties: {
      ...MediaJobStateChangeEventData.type.modelProperties,
      outputs: {
        serializedName: "outputs",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MediaJobOutput",
            },
          },
        },
      },
    },
  },
};

export const MediaJobErroredEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobErroredEventData",
    modelProperties: {
      ...MediaJobStateChangeEventData.type.modelProperties,
      outputs: {
        serializedName: "outputs",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MediaJobOutput",
            },
          },
        },
      },
    },
  },
};

export const MediaJobOutputAsset: coreClient.CompositeMapper = {
  serializedName: "#Microsoft.Media.JobOutputAsset",
  type: {
    name: "Composite",
    className: "MediaJobOutputAsset",
    uberParent: "MediaJobOutput",
    polymorphicDiscriminator: MediaJobOutput.type.polymorphicDiscriminator,
    modelProperties: {
      ...MediaJobOutput.type.modelProperties,
      assetName: {
        serializedName: "assetName",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MediaJobOutputCanceledEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobOutputCanceledEventData",
    modelProperties: {
      ...MediaJobOutputStateChangeEventData.type.modelProperties,
    },
  },
};

export const MediaJobOutputCancelingEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobOutputCancelingEventData",
    modelProperties: {
      ...MediaJobOutputStateChangeEventData.type.modelProperties,
    },
  },
};

export const MediaJobOutputErroredEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobOutputErroredEventData",
    modelProperties: {
      ...MediaJobOutputStateChangeEventData.type.modelProperties,
    },
  },
};

export const MediaJobOutputFinishedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobOutputFinishedEventData",
    modelProperties: {
      ...MediaJobOutputStateChangeEventData.type.modelProperties,
    },
  },
};

export const MediaJobOutputProcessingEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobOutputProcessingEventData",
    modelProperties: {
      ...MediaJobOutputStateChangeEventData.type.modelProperties,
    },
  },
};

export const MediaJobOutputScheduledEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MediaJobOutputScheduledEventData",
    modelProperties: {
      ...MediaJobOutputStateChangeEventData.type.modelProperties,
    },
  },
};

export const MapsGeofenceEnteredEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MapsGeofenceEnteredEventData",
    modelProperties: {
      ...MapsGeofenceEvent.type.modelProperties,
    },
  },
};

export const MapsGeofenceExitedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MapsGeofenceExitedEventData",
    modelProperties: {
      ...MapsGeofenceEvent.type.modelProperties,
    },
  },
};

export const MapsGeofenceResultEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MapsGeofenceResultEventData",
    modelProperties: {
      ...MapsGeofenceEvent.type.modelProperties,
    },
  },
};

export const AppConfigurationSnapshotCreatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AppConfigurationSnapshotCreatedEventData",
      modelProperties: {
        ...AppConfigurationSnapshotEventData.type.modelProperties,
      },
    },
  };

export const AppConfigurationSnapshotModifiedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AppConfigurationSnapshotModifiedEventData",
      modelProperties: {
        ...AppConfigurationSnapshotEventData.type.modelProperties,
      },
    },
  };

export const AcsRouterJobEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterJobEventData",
    modelProperties: {
      ...AcsRouterEventData.type.modelProperties,
      queueId: {
        serializedName: "queueId",
        required: true,
        type: {
          name: "String",
        },
      },
      labels: {
        serializedName: "labels",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      tags: {
        serializedName: "tags",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const AcsRouterWorkerEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterWorkerEventData",
    modelProperties: {
      ...AcsRouterEventData.type.modelProperties,
      workerId: {
        serializedName: "workerId",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsChatMessageEventBase: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatMessageEventBase",
    modelProperties: {
      ...AcsChatEventBase.type.modelProperties,
      messageId: {
        serializedName: "messageId",
        required: true,
        type: {
          name: "String",
        },
      },
      senderCommunicationIdentifier: {
        serializedName: "senderCommunicationIdentifier",
        type: {
          name: "Composite",
          className: "CommunicationIdentifierModel",
        },
      },
      senderDisplayName: {
        serializedName: "senderDisplayName",
        required: true,
        type: {
          name: "String",
        },
      },
      composeTime: {
        serializedName: "composeTime",
        required: true,
        type: {
          name: "String",
        },
      },
      type: {
        serializedName: "type",
        required: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "version",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const AcsChatThreadEventBase: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatThreadEventBase",
    modelProperties: {
      ...AcsChatEventBase.type.modelProperties,
      createTime: {
        serializedName: "createTime",
        required: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "version",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const AcsChatMessageEventInThreadBase: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatMessageEventInThreadBase",
    modelProperties: {
      ...AcsChatEventInThreadBase.type.modelProperties,
      messageId: {
        serializedName: "messageId",
        required: true,
        type: {
          name: "String",
        },
      },
      senderCommunicationIdentifier: {
        serializedName: "senderCommunicationIdentifier",
        type: {
          name: "Composite",
          className: "CommunicationIdentifierModel",
        },
      },
      senderDisplayName: {
        serializedName: "senderDisplayName",
        required: true,
        type: {
          name: "String",
        },
      },
      composeTime: {
        serializedName: "composeTime",
        required: true,
        type: {
          name: "String",
        },
      },
      type: {
        serializedName: "type",
        required: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "version",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const AcsChatThreadEventInThreadBase: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatThreadEventInThreadBase",
    modelProperties: {
      ...AcsChatEventInThreadBase.type.modelProperties,
      createTime: {
        serializedName: "createTime",
        required: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "version",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const AcsChatParticipantAddedToThreadEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsChatParticipantAddedToThreadEventData",
      modelProperties: {
        ...AcsChatEventInThreadBase.type.modelProperties,
        time: {
          serializedName: "time",
          required: true,
          type: {
            name: "String",
          },
        },
        addedByCommunicationIdentifier: {
          serializedName: "addedByCommunicationIdentifier",
          type: {
            name: "Composite",
            className: "CommunicationIdentifierModel",
          },
        },
        participantAdded: {
          serializedName: "participantAdded",
          type: {
            name: "Composite",
            className: "AcsChatThreadParticipant",
          },
        },
        version: {
          serializedName: "version",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const AcsChatParticipantRemovedFromThreadEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsChatParticipantRemovedFromThreadEventData",
      modelProperties: {
        ...AcsChatEventInThreadBase.type.modelProperties,
        time: {
          serializedName: "time",
          required: true,
          type: {
            name: "String",
          },
        },
        removedByCommunicationIdentifier: {
          serializedName: "removedByCommunicationIdentifier",
          type: {
            name: "Composite",
            className: "CommunicationIdentifierModel",
          },
        },
        participantRemoved: {
          serializedName: "participantRemoved",
          type: {
            name: "Composite",
            className: "AcsChatThreadParticipant",
          },
        },
        version: {
          serializedName: "version",
          required: true,
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const AcsSmsDeliveryReportReceivedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsSmsDeliveryReportReceivedEventData",
      modelProperties: {
        ...AcsSmsEventBase.type.modelProperties,
        deliveryStatus: {
          serializedName: "deliveryStatus",
          required: true,
          type: {
            name: "String",
          },
        },
        deliveryStatusDetails: {
          serializedName: "deliveryStatusDetails",
          required: true,
          type: {
            name: "String",
          },
        },
        deliveryAttempts: {
          serializedName: "deliveryAttempts",
          required: true,
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "AcsSmsDeliveryAttempt",
              },
            },
          },
        },
        receivedTimestamp: {
          serializedName: "receivedTimestamp",
          required: true,
          type: {
            name: "String",
          },
        },
        tag: {
          serializedName: "tag",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsSmsReceivedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsSmsReceivedEventData",
    modelProperties: {
      ...AcsSmsEventBase.type.modelProperties,
      message: {
        serializedName: "message",
        type: {
          name: "String",
        },
      },
      receivedTimestamp: {
        serializedName: "receivedTimestamp",
        type: {
          name: "String",
        },
      },
      segmentCount: {
        serializedName: "segmentCount",
        required: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const AcsMessageReceivedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsMessageReceivedEventData",
    modelProperties: {
      ...AcsMessageEventData.type.modelProperties,
      content: {
        serializedName: "content",
        type: {
          name: "String",
        },
      },
      messageId: {
        serializedName: "messageId",
        type: {
          name: "String",
        },
      },
      channelKind: {
        serializedName: "channelType",
        type: {
          name: "String",
        },
      },
      messageType: {
        serializedName: "messageType",
        required: true,
        type: {
          name: "String",
        },
      },
      mediaContent: {
        serializedName: "media",
        type: {
          name: "Composite",
          className: "AcsMessageMediaContent",
        },
      },
      reaction: {
        serializedName: "reaction",
        type: {
          name: "Composite",
          className: "AcsMessageReactionContent",
        },
      },
      context: {
        serializedName: "context",
        type: {
          name: "Composite",
          className: "AcsMessageContext",
        },
      },
      button: {
        serializedName: "button",
        type: {
          name: "Composite",
          className: "AcsMessageButtonContent",
        },
      },
      interactiveContent: {
        serializedName: "interactive",
        type: {
          name: "Composite",
          className: "AcsMessageInteractiveContent",
        },
      },
    },
  },
};

export const AcsMessageDeliveryStatusUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsMessageDeliveryStatusUpdatedEventData",
      modelProperties: {
        ...AcsMessageEventData.type.modelProperties,
        messageId: {
          serializedName: "messageId",
          required: true,
          type: {
            name: "String",
          },
        },
        status: {
          serializedName: "status",
          required: true,
          type: {
            name: "String",
          },
        },
        channelKind: {
          serializedName: "channelType",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ContainerServiceClusterSupportEndedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerServiceClusterSupportEndedEventData",
      modelProperties: {
        ...ContainerServiceClusterSupportEventData.type.modelProperties,
      },
    },
  };

export const ContainerServiceClusterSupportEndingEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerServiceClusterSupportEndingEventData",
      modelProperties: {
        ...ContainerServiceClusterSupportEventData.type.modelProperties,
      },
    },
  };

export const ContainerServiceNodePoolRollingStartedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerServiceNodePoolRollingStartedEventData",
      modelProperties: {
        ...ContainerServiceNodePoolRollingEventData.type.modelProperties,
      },
    },
  };

export const ContainerServiceNodePoolRollingSucceededEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerServiceNodePoolRollingSucceededEventData",
      modelProperties: {
        ...ContainerServiceNodePoolRollingEventData.type.modelProperties,
      },
    },
  };

export const ContainerServiceNodePoolRollingFailedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ContainerServiceNodePoolRollingFailedEventData",
      modelProperties: {
        ...ContainerServiceNodePoolRollingEventData.type.modelProperties,
      },
    },
  };

export const ResourceNotificationsHealthResourcesAvailabilityStatusChangedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "ResourceNotificationsHealthResourcesAvailabilityStatusChangedEventData",
      modelProperties: {
        ...ResourceNotificationsResourceUpdatedEventData.type.modelProperties,
      },
    },
  };

export const ResourceNotificationsHealthResourcesAnnotatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ResourceNotificationsHealthResourcesAnnotatedEventData",
      modelProperties: {
        ...ResourceNotificationsResourceUpdatedEventData.type.modelProperties,
      },
    },
  };

export const ResourceNotificationsResourceManagementCreatedOrUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "ResourceNotificationsResourceManagementCreatedOrUpdatedEventData",
      modelProperties: {
        ...ResourceNotificationsResourceUpdatedEventData.type.modelProperties,
      },
    },
  };

export const ResourceNotificationsContainerServiceEventResourcesScheduledEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "ResourceNotificationsContainerServiceEventResourcesScheduledEventData",
      modelProperties: {
        ...ResourceNotificationsResourceUpdatedEventData.type.modelProperties,
      },
    },
  };

export const ResourceNotificationsResourceManagementDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "ResourceNotificationsResourceManagementDeletedEventData",
      modelProperties: {
        ...ResourceNotificationsResourceDeletedEventData.type.modelProperties,
      },
    },
  };

export const AvsPrivateCloudUpdatingEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsPrivateCloudUpdatingEventData",
    modelProperties: {
      ...AvsPrivateCloudEventData.type.modelProperties,
    },
  },
};

export const AvsPrivateCloudUpdatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsPrivateCloudUpdatedEventData",
    modelProperties: {
      ...AvsPrivateCloudEventData.type.modelProperties,
    },
  },
};

export const AvsPrivateCloudFailedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsPrivateCloudFailedEventData",
    modelProperties: {
      ...AvsPrivateCloudEventData.type.modelProperties,
      failureMessage: {
        serializedName: "failureMessage",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AvsClusterCreatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsClusterCreatedEventData",
    modelProperties: {
      ...AvsClusterEventData.type.modelProperties,
    },
  },
};

export const AvsClusterDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsClusterDeletedEventData",
    modelProperties: {
      ...AvsClusterEventData.type.modelProperties,
    },
  },
};

export const AvsClusterUpdatingEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsClusterUpdatingEventData",
    modelProperties: {
      ...AvsClusterEventData.type.modelProperties,
    },
  },
};

export const AvsClusterUpdatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsClusterUpdatedEventData",
    modelProperties: {
      ...AvsClusterEventData.type.modelProperties,
    },
  },
};

export const AvsClusterFailedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsClusterFailedEventData",
    modelProperties: {
      ...AvsClusterEventData.type.modelProperties,
      failureMessage: {
        serializedName: "failureMessage",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AvsScriptExecutionStartedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsScriptExecutionStartedEventData",
    modelProperties: {
      ...AvsScriptExecutionEventData.type.modelProperties,
    },
  },
};

export const AvsScriptExecutionFinishedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsScriptExecutionFinishedEventData",
    modelProperties: {
      ...AvsScriptExecutionEventData.type.modelProperties,
      namedOutputs: {
        serializedName: "namedOutputs",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const AvsScriptExecutionCancelledEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AvsScriptExecutionCancelledEventData",
      modelProperties: {
        ...AvsScriptExecutionEventData.type.modelProperties,
      },
    },
  };

export const AvsScriptExecutionFailedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AvsScriptExecutionFailedEventData",
    modelProperties: {
      ...AvsScriptExecutionEventData.type.modelProperties,
      failureMessage: {
        serializedName: "failureMessage",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsRouterJobCancelledEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterJobCancelledEventData",
    modelProperties: {
      ...AcsRouterJobEventData.type.modelProperties,
      note: {
        serializedName: "note",
        required: true,
        type: {
          name: "String",
        },
      },
      dispositionCode: {
        serializedName: "dispositionCode",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsRouterJobClassificationFailedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsRouterJobClassificationFailedEventData",
      modelProperties: {
        ...AcsRouterJobEventData.type.modelProperties,
        classificationPolicyId: {
          serializedName: "classificationPolicyId",
          required: true,
          type: {
            name: "String",
          },
        },
        errors: {
          serializedName: "errors",
          required: true,
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "AcsRouterCommunicationError",
              },
            },
          },
        },
      },
    },
  };

export const AcsRouterJobClassifiedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterJobClassifiedEventData",
    modelProperties: {
      ...AcsRouterJobEventData.type.modelProperties,
      queueDetails: {
        serializedName: "queueDetails",
        type: {
          name: "Composite",
          className: "AcsRouterQueueDetails",
        },
      },
      classificationPolicyId: {
        serializedName: "classificationPolicyId",
        required: true,
        type: {
          name: "String",
        },
      },
      priority: {
        serializedName: "priority",
        required: true,
        type: {
          name: "Number",
        },
      },
      attachedWorkerSelectors: {
        serializedName: "attachedWorkerSelectors",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AcsRouterWorkerSelector",
            },
          },
        },
      },
    },
  },
};

export const AcsRouterJobClosedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterJobClosedEventData",
    modelProperties: {
      ...AcsRouterJobEventData.type.modelProperties,
      assignmentId: {
        serializedName: "assignmentId",
        required: true,
        type: {
          name: "String",
        },
      },
      workerId: {
        serializedName: "workerId",
        required: true,
        type: {
          name: "String",
        },
      },
      dispositionCode: {
        serializedName: "dispositionCode",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsRouterJobCompletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterJobCompletedEventData",
    modelProperties: {
      ...AcsRouterJobEventData.type.modelProperties,
      assignmentId: {
        serializedName: "assignmentId",
        required: true,
        type: {
          name: "String",
        },
      },
      workerId: {
        serializedName: "workerId",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsRouterJobDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterJobDeletedEventData",
    modelProperties: {
      ...AcsRouterJobEventData.type.modelProperties,
    },
  },
};

export const AcsRouterJobExceptionTriggeredEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsRouterJobExceptionTriggeredEventData",
      modelProperties: {
        ...AcsRouterJobEventData.type.modelProperties,
        ruleKey: {
          serializedName: "ruleKey",
          required: true,
          type: {
            name: "String",
          },
        },
        exceptionRuleId: {
          serializedName: "exceptionRuleId",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsRouterJobQueuedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterJobQueuedEventData",
    modelProperties: {
      ...AcsRouterJobEventData.type.modelProperties,
      priority: {
        serializedName: "priority",
        required: true,
        type: {
          name: "Number",
        },
      },
      attachedWorkerSelectors: {
        serializedName: "attachedWorkerSelectors",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AcsRouterWorkerSelector",
            },
          },
        },
      },
      requestedWorkerSelectors: {
        serializedName: "requestedWorkerSelectors",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AcsRouterWorkerSelector",
            },
          },
        },
      },
    },
  },
};

export const AcsRouterJobReceivedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterJobReceivedEventData",
    modelProperties: {
      ...AcsRouterJobEventData.type.modelProperties,
      jobStatus: {
        serializedName: "jobStatus",
        type: {
          name: "String",
        },
      },
      classificationPolicyId: {
        serializedName: "classificationPolicyId",
        type: {
          name: "String",
        },
      },
      priority: {
        serializedName: "priority",
        type: {
          name: "Number",
        },
      },
      requestedWorkerSelectors: {
        serializedName: "requestedWorkerSelectors",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AcsRouterWorkerSelector",
            },
          },
        },
      },
      scheduledOn: {
        serializedName: "scheduledOn",
        type: {
          name: "String",
        },
      },
      unavailableForMatching: {
        serializedName: "unavailableForMatching",
        required: true,
        type: {
          name: "Boolean",
        },
      },
    },
  },
};

export const AcsRouterJobSchedulingFailedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsRouterJobSchedulingFailedEventData",
      modelProperties: {
        ...AcsRouterJobEventData.type.modelProperties,
        priority: {
          serializedName: "priority",
          required: true,
          type: {
            name: "Number",
          },
        },
        expiredAttachedWorkerSelectors: {
          serializedName: "expiredAttachedWorkerSelectors",
          required: true,
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "AcsRouterWorkerSelector",
              },
            },
          },
        },
        expiredRequestedWorkerSelectors: {
          serializedName: "expiredRequestedWorkerSelectors",
          required: true,
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "AcsRouterWorkerSelector",
              },
            },
          },
        },
        scheduledOn: {
          serializedName: "scheduledOn",
          required: true,
          type: {
            name: "String",
          },
        },
        failureReason: {
          serializedName: "failureReason",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsRouterJobUnassignedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterJobUnassignedEventData",
    modelProperties: {
      ...AcsRouterJobEventData.type.modelProperties,
      assignmentId: {
        serializedName: "assignmentId",
        required: true,
        type: {
          name: "String",
        },
      },
      workerId: {
        serializedName: "workerId",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsRouterJobWaitingForActivationEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsRouterJobWaitingForActivationEventData",
      modelProperties: {
        ...AcsRouterJobEventData.type.modelProperties,
        priority: {
          serializedName: "priority",
          type: {
            name: "Number",
          },
        },
        expiredAttachedWorkerSelectors: {
          serializedName: "expiredAttachedWorkerSelectors",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "AcsRouterWorkerSelector",
              },
            },
          },
        },
        expiredRequestedWorkerSelectors: {
          serializedName: "expiredRequestedWorkerSelectors",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "AcsRouterWorkerSelector",
              },
            },
          },
        },
        scheduledOn: {
          serializedName: "scheduledOn",
          type: {
            name: "String",
          },
        },
        unavailableForMatching: {
          serializedName: "unavailableForMatching",
          required: true,
          type: {
            name: "Boolean",
          },
        },
      },
    },
  };

export const AcsRouterJobWorkerSelectorsExpiredEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsRouterJobWorkerSelectorsExpiredEventData",
      modelProperties: {
        ...AcsRouterJobEventData.type.modelProperties,
        expiredRequestedWorkerSelectors: {
          serializedName: "expiredRequestedWorkerSelectors",
          required: true,
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "AcsRouterWorkerSelector",
              },
            },
          },
        },
        expiredAttachedWorkerSelectors: {
          serializedName: "expiredAttachedWorkerSelectors",
          required: true,
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "AcsRouterWorkerSelector",
              },
            },
          },
        },
      },
    },
  };

export const AcsRouterWorkerDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterWorkerDeletedEventData",
    modelProperties: {
      ...AcsRouterWorkerEventData.type.modelProperties,
    },
  },
};

export const AcsRouterWorkerOfferAcceptedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsRouterWorkerOfferAcceptedEventData",
      modelProperties: {
        ...AcsRouterWorkerEventData.type.modelProperties,
        queueId: {
          serializedName: "queueId",
          required: true,
          type: {
            name: "String",
          },
        },
        offerId: {
          serializedName: "offerId",
          required: true,
          type: {
            name: "String",
          },
        },
        assignmentId: {
          serializedName: "assignmentId",
          required: true,
          type: {
            name: "String",
          },
        },
        jobPriority: {
          serializedName: "jobPriority",
          required: true,
          type: {
            name: "Number",
          },
        },
        workerLabels: {
          serializedName: "workerLabels",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
        workerTags: {
          serializedName: "workerTags",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
        jobLabels: {
          serializedName: "jobLabels",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
        jobTags: {
          serializedName: "jobTags",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
      },
    },
  };

export const AcsRouterWorkerOfferDeclinedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsRouterWorkerOfferDeclinedEventData",
      modelProperties: {
        ...AcsRouterWorkerEventData.type.modelProperties,
        queueId: {
          serializedName: "queueId",
          required: true,
          type: {
            name: "String",
          },
        },
        offerId: {
          serializedName: "offerId",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsRouterWorkerOfferExpiredEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsRouterWorkerOfferExpiredEventData",
      modelProperties: {
        ...AcsRouterWorkerEventData.type.modelProperties,
        queueId: {
          serializedName: "queueId",
          required: true,
          type: {
            name: "String",
          },
        },
        offerId: {
          serializedName: "offerId",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsRouterWorkerOfferIssuedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsRouterWorkerOfferIssuedEventData",
    modelProperties: {
      ...AcsRouterWorkerEventData.type.modelProperties,
      queueId: {
        serializedName: "queueId",
        required: true,
        type: {
          name: "String",
        },
      },
      offerId: {
        serializedName: "offerId",
        required: true,
        type: {
          name: "String",
        },
      },
      jobPriority: {
        serializedName: "jobPriority",
        required: true,
        type: {
          name: "Number",
        },
      },
      workerLabels: {
        serializedName: "workerLabels",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      offeredOn: {
        serializedName: "offeredOn",
        required: true,
        type: {
          name: "String",
        },
      },
      expiresOn: {
        serializedName: "expiresOn",
        required: true,
        type: {
          name: "String",
        },
      },
      workerTags: {
        serializedName: "workerTags",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      jobLabels: {
        serializedName: "jobLabels",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      jobTags: {
        serializedName: "jobTags",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const AcsRouterWorkerOfferRevokedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsRouterWorkerOfferRevokedEventData",
      modelProperties: {
        ...AcsRouterWorkerEventData.type.modelProperties,
        queueId: {
          serializedName: "queueId",
          required: true,
          type: {
            name: "String",
          },
        },
        offerId: {
          serializedName: "offerId",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsChatMessageReceivedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatMessageReceivedEventData",
    modelProperties: {
      ...AcsChatMessageEventBase.type.modelProperties,
      messageBody: {
        serializedName: "messageBody",
        required: true,
        type: {
          name: "String",
        },
      },
      metadata: {
        serializedName: "metadata",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const AcsChatMessageEditedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatMessageEditedEventData",
    modelProperties: {
      ...AcsChatMessageEventBase.type.modelProperties,
      messageBody: {
        serializedName: "messageBody",
        required: true,
        type: {
          name: "String",
        },
      },
      metadata: {
        serializedName: "metadata",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      editTime: {
        serializedName: "editTime",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsChatMessageDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatMessageDeletedEventData",
    modelProperties: {
      ...AcsChatMessageEventBase.type.modelProperties,
      deleteTime: {
        serializedName: "deleteTime",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsChatThreadCreatedWithUserEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsChatThreadCreatedWithUserEventData",
      modelProperties: {
        ...AcsChatThreadEventBase.type.modelProperties,
        createdByCommunicationIdentifier: {
          serializedName: "createdByCommunicationIdentifier",
          type: {
            name: "Composite",
            className: "CommunicationIdentifierModel",
          },
        },
        properties: {
          serializedName: "properties",
          required: true,
          type: {
            name: "Dictionary",
            value: {
              type: { name: "Dictionary", value: { type: { name: "any" } } },
            },
          },
        },
        metadata: {
          serializedName: "metadata",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
        participants: {
          serializedName: "participants",
          required: true,
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "AcsChatThreadParticipant",
              },
            },
          },
        },
      },
    },
  };

export const AcsChatThreadWithUserDeletedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsChatThreadWithUserDeletedEventData",
      modelProperties: {
        ...AcsChatThreadEventBase.type.modelProperties,
        deletedByCommunicationIdentifier: {
          serializedName: "deletedByCommunicationIdentifier",
          type: {
            name: "Composite",
            className: "CommunicationIdentifierModel",
          },
        },
        deleteTime: {
          serializedName: "deleteTime",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsChatThreadPropertiesUpdatedPerUserEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsChatThreadPropertiesUpdatedPerUserEventData",
      modelProperties: {
        ...AcsChatThreadEventBase.type.modelProperties,
        editedByCommunicationIdentifier: {
          serializedName: "editedByCommunicationIdentifier",
          type: {
            name: "Composite",
            className: "CommunicationIdentifierModel",
          },
        },
        editTime: {
          serializedName: "editTime",
          required: true,
          type: {
            name: "String",
          },
        },
        metadata: {
          serializedName: "metadata",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
        properties: {
          serializedName: "properties",
          required: true,
          type: {
            name: "Dictionary",
            value: {
              type: { name: "Dictionary", value: { type: { name: "any" } } },
            },
          },
        },
      },
    },
  };

export const AcsChatParticipantAddedToThreadWithUserEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsChatParticipantAddedToThreadWithUserEventData",
      modelProperties: {
        ...AcsChatThreadEventBase.type.modelProperties,
        time: {
          serializedName: "time",
          required: true,
          type: {
            name: "String",
          },
        },
        addedByCommunicationIdentifier: {
          serializedName: "addedByCommunicationIdentifier",
          type: {
            name: "Composite",
            className: "CommunicationIdentifierModel",
          },
        },
        participantAdded: {
          serializedName: "participantAdded",
          type: {
            name: "Composite",
            className: "AcsChatThreadParticipant",
          },
        },
      },
    },
  };

export const AcsChatParticipantRemovedFromThreadWithUserEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsChatParticipantRemovedFromThreadWithUserEventData",
      modelProperties: {
        ...AcsChatThreadEventBase.type.modelProperties,
        time: {
          serializedName: "time",
          required: true,
          type: {
            name: "String",
          },
        },
        removedByCommunicationIdentifier: {
          serializedName: "removedByCommunicationIdentifier",
          type: {
            name: "Composite",
            className: "CommunicationIdentifierModel",
          },
        },
        participantRemoved: {
          serializedName: "participantRemoved",
          type: {
            name: "Composite",
            className: "AcsChatThreadParticipant",
          },
        },
      },
    },
  };

export const AcsChatMessageReceivedInThreadEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsChatMessageReceivedInThreadEventData",
      modelProperties: {
        ...AcsChatMessageEventInThreadBase.type.modelProperties,
        messageBody: {
          serializedName: "messageBody",
          required: true,
          type: {
            name: "String",
          },
        },
        metadata: {
          serializedName: "metadata",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
      },
    },
  };

export const AcsChatMessageEditedInThreadEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsChatMessageEditedInThreadEventData",
      modelProperties: {
        ...AcsChatMessageEventInThreadBase.type.modelProperties,
        messageBody: {
          serializedName: "messageBody",
          required: true,
          type: {
            name: "String",
          },
        },
        metadata: {
          serializedName: "metadata",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
        editTime: {
          serializedName: "editTime",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsChatMessageDeletedInThreadEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsChatMessageDeletedInThreadEventData",
      modelProperties: {
        ...AcsChatMessageEventInThreadBase.type.modelProperties,
        deleteTime: {
          serializedName: "deleteTime",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const AcsChatThreadCreatedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatThreadCreatedEventData",
    modelProperties: {
      ...AcsChatThreadEventInThreadBase.type.modelProperties,
      createdByCommunicationIdentifier: {
        serializedName: "createdByCommunicationIdentifier",
        type: {
          name: "Composite",
          className: "CommunicationIdentifierModel",
        },
      },
      properties: {
        serializedName: "properties",
        required: true,
        type: {
          name: "Dictionary",
          value: {
            type: { name: "Dictionary", value: { type: { name: "any" } } },
          },
        },
      },
      metadata: {
        serializedName: "metadata",
        required: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      participants: {
        serializedName: "participants",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AcsChatThreadParticipant",
            },
          },
        },
      },
    },
  },
};

export const AcsChatThreadDeletedEventData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AcsChatThreadDeletedEventData",
    modelProperties: {
      ...AcsChatThreadEventInThreadBase.type.modelProperties,
      deletedByCommunicationIdentifier: {
        serializedName: "deletedByCommunicationIdentifier",
        type: {
          name: "Composite",
          className: "CommunicationIdentifierModel",
        },
      },
      deleteTime: {
        serializedName: "deleteTime",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const AcsChatThreadPropertiesUpdatedEventData: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "AcsChatThreadPropertiesUpdatedEventData",
      modelProperties: {
        ...AcsChatThreadEventInThreadBase.type.modelProperties,
        editedByCommunicationIdentifier: {
          serializedName: "editedByCommunicationIdentifier",
          type: {
            name: "Composite",
            className: "CommunicationIdentifierModel",
          },
        },
        editTime: {
          serializedName: "editTime",
          required: true,
          type: {
            name: "String",
          },
        },
        properties: {
          serializedName: "properties",
          required: true,
          type: {
            name: "Dictionary",
            value: {
              type: { name: "Dictionary", value: { type: { name: "any" } } },
            },
          },
        },
        metadata: {
          serializedName: "metadata",
          required: true,
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
      },
    },
  };

export let discriminators = {
  MediaJobOutput: MediaJobOutput,
  "MediaJobOutput.#Microsoft.Media.JobOutputAsset": MediaJobOutputAsset,
};
